<meta name="viewport"
    content="user-scalable=no, initial-scale=1, maximum-scale=1, minimum-scale=1, width=device-width, height=device-height, target-densitydpi=device-dpi" />
<div class="container-fluid">
    <app-page-title title="Dashboard"></app-page-title>
    <div class="card">
        <div class="card-body">
            <div class="row">
                <label class="label" style="display: flex;justify-content:center;">View By</label>
                <div class="mobile-dashboard" style="display: flex;justify-content:center;">
                    <div class="btn-group col-lg-4 col-md-6 col-sm-12 col-12 btn-group-example" role="group">
                        <button type="button" [ngClass]="groupingType ==='day'? 'btn-primary':'btn-outline-primary'"
                            class="btn w-20" (click)="filterDay()">Day</button>
                        <button type="button" [ngClass]="groupingType ==='month'? 'btn-primary':'btn-outline-primary'"
                            class="btn w-20" (click)="filterMonth()">Month</button>
                        <button type="button" [ngClass]="groupingType ==='quarter'? 'btn-primary':'btn-outline-primary'"
                            class="btn w-20" (click)="filterQuarter()">Quarter</button>
                        <button type="button" [ngClass]="groupingType ==='year'? 'btn-primary':'btn-outline-primary'"
                            class="btn w-20" (click)="filterYear()">Year</button>
                        <button type="button" [ngClass]="groupingType ==='range'? 'btn-primary':'btn-outline-primary'"
                            class="btn w-20" (click)="filterRange()">Range</button>
                    </div>
                </div>
            </div>
            <br/>
            <div class="row" style="margin-top :0px !important;">
                <div class="col-lg-12 col-md-4 col-sm-12" style="display: flex;justify-content:center;">
                    <div *ngIf="!compareData" class="col-lg-4 col-md-6 col-sm-12 col-12" style="display: flex;">
                        <button class="btn btn-block btn-primary" (click)="openComparison()">Compare
                            Data</button>
                    </div>
                </div>
                <div class="col-lg-12 col-md-4 col-sm-12" style="display: flex;justify-content:center;">
                    <div *ngIf="compareData" class="col-lg-4 col-md-6 col-sm-12 col-12"style="display: flex;">
                        <button class="btn btn-block btn-danger" (click)="closedComparison()">Closed Comparison</button>
                    </div>
                </div>
            </div>
            <!-- Range -->
            <div class="row">
                <div #dll class="col-lg-3 col-md-6 col-sm-12">
                    <label class="label">Operating Unit</label>
                    <ngx-dropdown-treeview [config]="config" *ngIf="!showSingle" [items]="operatingUnitList"
                        (selectedChange)="updateOperating($event)" buttonClass="btn-outline-primary">
                    </ngx-dropdown-treeview>
                    <ngx-dropdown-treeview-select *ngIf="showSingle" [items]="operatingUnitList"
                        [(value)]="operatingSelSingleVal" buttonClass="btn-outline-primary" [disabled]="showSingle">
                    </ngx-dropdown-treeview-select>
                </div>
                
                <div *ngIf="groupingType==='day' && !compareData" class="col-lg-3 col-md-6 col-sm-12">
                    <label class="label">Date</label>
                    <input [(ngModel)]="selDate"  class="form-control"
                        placeholder="dd/MM/yyyy" type="date">
                </div>
                <div *ngIf="(groupingType==='month' || groupingType==='year' || groupingType==='range'|| groupingType==='quarter') && !compareData"
                    class="col-lg-3 col-md-6 col-sm-12">
                    <label class="label">Year</label>
                    <ng-select [items]="years" bindValue="year" [(ngModel)]="selYear" (ngModelChange)="selYearChange()">
                    </ng-select>
                </div>

                <div *ngIf="groupingType==='range' && !compareData" class="col-lg-3 col-md-6 col-sm-12">
                    <label class="label">Month From (Year {{selYear}})</label>
                    <ng-select [items]="monthsFrom" bindValue="month" bindLabel="desc" [(ngModel)]="selMonthFrom"
                        (change)="selMonthFromChange()">
                    </ng-select>
                </div>

                <div *ngIf="groupingType==='range' && !compareData" class="col-lg-3 col-md-6 col-sm-12">
                    <label class="label">Month To (Year {{selYear}})</label>
                    <ng-select [items]="monthsTo" bindValue="month" bindLabel="desc" [(ngModel)]="selMonthTo"
                        (change)="selMonthToChange()">
                    </ng-select>
                </div>

                <div *ngIf="groupingType==='month' && !compareData" class="col-lg-3 col-md-6 col-sm-12">
                    <label class="label">Month</label>
                    <ng-select [items]="months" bindValue="month" bindLabel="desc" [(ngModel)]="selMonth"
                       >
                    </ng-select>
                </div>
                <div *ngIf="groupingType==='quarter' && !compareData" class="col-lg-3 col-md-6 col-sm-12">
                    <label class="label">Quarter</label>
                    <ng-select [(ngModel)]="selectedQuarter" (change)="selQuarterChange()">
                        <ng-option *ngFor="let quarter of QuaterList" [value]="quarter.value">{{quarter.title}}</ng-option>
                     </ng-select>
                </div>

            </div>
            <div class="row col-lg-2 col-md-4 col-sm-12">
                &nbsp;
            </div>
            <div class="row">
                <div class="col-lg-2 col-md-4 col-sm-12" style="align-self: end;">
                    <button class="btn btn-block btn-primary" (click)="filter()">Filter</button>
                </div>
            </div>
            <div *ngIf="!compareData">
                <div *ngIf="groupingType =='day'" class="row">
                <div class="row">&nbsp;</div>

                        <div style="text-align-last: center;">
                            <h6 style="font-size:14px !important;">Total No. of Submission Chart ({{this.newcurrentDate | date: 'dd/MM/yyyy'}})</h6>
                        </div>

                        <div id="dashboardPieChart"></div>

                        <div class="row">
                            <button class="btn btn-primary mo-mb-2 ms-1" type="button"
                                (click)="millProductivityPieChartDetailsCollapsed = !millProductivityPieChartDetailsCollapsed">
                                Show Chart Details
                            </button>
                            <div class="collapse" [ngbCollapse]="millProductivityPieChartDetailsCollapsed">
                                <div class="card card-body mb-0">

                                    <div class="card-body">
                                        <div class="row mb-md-2">
                                            <div class="col-sm-12 col-md-9 col-lg-10">
                                                <div class="dataTables_length table-responsive">
                                                    <label class="d-inline-flex align-items-center">Show
                                                        <select name="tickets-table_length" aria-controls="tickets-table"
                                                            name="pageSize" [(ngModel)]="pageSize"
                                                            class="form-control form-control-sm mx-2"
                                                            (change)="pageSizeChange($event)">
                                                            <option [ngValue]="10">10</option>
                                                            <option [ngValue]="25">25</option>
                                                            <option [ngValue]="50">50</option>
                                                            <option [ngValue]="100">100</option>
                                                        </select> entries</label>
                                                </div>
                                            </div>
                                        </div>
                                        <br />
                                        <div class="table-responsive">
                                            <table id="basic-datatable"
                                                class="table table-bordered dt-responsive nowrap no-footer dtr-inline">
                                                <thead class="">
                                                    <tr>
                                                        <th></th>
                                                        <th>Status</th>
                                                        <th>Total</th>
                                                    </tr>
                                                </thead>
                                                <tbody *ngFor="let items1 of millProducitivtyPieChartData;let i = index">
                                                    <tr>
                                                        <td align="center">
                                                            <a class="expand-row" (click)="chartDetailsDetails(i)">
                                                                +
                                                            </a>
                                                        </td>
                                                        <td>
                                                            <ngb-highlight [result]="items1.name"></ngb-highlight>
                                                        </td>
                                                        <td>
                                                            <ngb-highlight [result]="items1.total"></ngb-highlight>
                                                        </td>
                                                    </tr>
                                                    <tr *ngIf="showChartDetailsDetails[i]" class="sub-table no-bg">
                                                        <td colspan="15" class="p-0">
                                                            <table class="table mb-0 table-striped">
                                                                <thead class="bg-dark text-white">
                                                                    <tr>
                                                                        <th>OU</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr *ngFor="let items of items1.items;let e = index">
                                                                        <td>
                                                                            <ngb-highlight [result]="items.title">
                                                                            </ngb-highlight>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="row justify-content-md-between align-items-md-center mt-2">
                                            <div class="col-sm-12 col-md-5">
                                                <div class="dataTables_info mb-2" id="tickets-table_info" role="status"
                                                    aria-live="polite">
                                                    Showing
                                                    {{startIndex}} to
                                                    {{endIndex}} of {{totalRecords}}
                                                    entries
                                                </div>
                                            </div>
                                            <!-- Pagination -->
                                            <div class="col-sm-12 col-md-5">
                                                <div class="text-md-right float-md-end pagination-rounded">
                                                    <ngb-pagination [collectionSize]="totalRecords" [(page)]="page"
                                                        [pageSize]="pageSize" [maxSize]="5" [rotate]="true"
                                                        [boundaryLinks]="true" (pageChange)="pageChange($event)">
                                                    </ngb-pagination>
                                                </div>
                                            </div>
                                            <!-- End Pagination -->
                                        </div>
                                    </div>
                                </div>
                            </div>

                    </div>
                </div>
            </div>

            <div *ngIf="!compareData">
                <div *ngIf="groupingType !=='day'" class="row">
                    <div class="row">
                        <span style="font-weight:bold;">{{chartTitle}}</span>
                    </div>
                    <div id="dashboardBarLineChartOerKer"></div>
                    <div class="row">
                        <button class="btn btn-primary mo-mb-2 ms-1" type="button"
                            (click)="millProductivityOerKerChartDetailsCollapsed = !millProductivityOerKerChartDetailsCollapsed">
                            Show Chart Details
                        </button>
                        <div class="collapse" [ngbCollapse]="millProductivityOerKerChartDetailsCollapsed">
                            <div class="card card-body mb-0">

                                <div class="card-body">
                                    <div class="row mb-md-2">
                                        <div class="col-sm-12 col-md-9 col-lg-10">
                                            <div class="dataTables_length table-responsive">
                                                <label class="d-inline-flex align-items-center">Show
                                                    <select name="tickets-table_length" aria-controls="tickets-table"
                                                        name="pageSize" [(ngModel)]="pageSize"
                                                        class="form-control form-control-sm mx-2"
                                                        (change)="pageSizeChange($event)">
                                                        <option [ngValue]="10">10</option>
                                                        <option [ngValue]="25">25</option>
                                                        <option [ngValue]="50">50</option>
                                                        <option [ngValue]="100">100</option>
                                                    </select> entries</label>
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                    <div class="table-responsive">
                                        <table id="basic-datatable"
                                            class="table table-bordered dt-responsive nowrap no-footer dtr-inline">
                                            <thead class="">
                                                <tr>
                                                    <th></th>
                                                    <th>{{SubChartLabel}}</th>
                                                    <th>OER Total</th>
                                                    <th>KER Total</th> 
                                                    <th>Budget OER Total</th>
                                                    <th>Budget KER Total</th>
                                                </tr>
                                            </thead>
                                            <tbody *ngFor="let items of millProductivityOerKerChartData;let i = index">
                                                <tr>
                                                    <td align="center">
                                                        <a class="expand-row" (click)="chartDetailsDetails(i)">
                                                            +
                                                        </a>
                                                    </td>
                                                    <td>
                                                        <ngb-highlight [result]="items.header"></ngb-highlight>
                                                    </td>
                                                    <td>
                                                        <ngb-highlight [result]="items.oerTotal| number
                                                        : '1.2-2'">
                                                        </ngb-highlight>
                                                    </td>
                                                    <td>
                                                        <ngb-highlight [result]="items.kerTotal| number
                                                        : '1.2-2'">
                                                        </ngb-highlight>
                                                    </td>
                                                    <td>
                                                        <ngb-highlight [result]="items.budgetOERTotal| number
                                                        : '1.2-2'">
                                                        </ngb-highlight>
                                                    </td>
                                                    <td>
                                                        <ngb-highlight [result]="items.budgetKERTotal| number
                                                        : '1.2-2'">
                                                        </ngb-highlight>
                                                    </td>
                                                    
                                                </tr>
                                                <tr *ngIf="showChartDetailsDetails[i]" class="sub-table no-bg">

                                                    <td align="center"> </td>
                                                    <td colspan="15" class="p-0">
                                                        <table class="table mb-0 table-striped">
                                                            <thead class="bg-dark text-white">
                                                                <tr>
                                                                    <th>OU</th>
                                                                    <th>OER</th>
                                                                    <th>KER</th>
                                                                    <th>Budget OER</th>
                                                                    <th>Budget KER</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr *ngFor="let items1 of items.tablesItems;let e = index">
                                                                    <td>
                                                                        <ngb-highlight [result]="items1.title">
                                                                        </ngb-highlight>
                                                                    </td>
                                                                    <td>
                                                                        <ngb-highlight [result]="items1.oer| number
                                                            : '1.2-2'">
                                                                        </ngb-highlight>
                                                                    </td>
                                                                    <td>
                                                                        <ngb-highlight [result]="items1.ker| number
                                                            : '1.2-2'">
                                                                        </ngb-highlight>
                                                                    </td>
                                                                    <td>
                                                                        <ngb-highlight [result]="items1.budgetOER| number
                                                            : '1.2-2'">
                                                                        </ngb-highlight>
                                                                    </td>
                                                                    <td>
                                                                        <ngb-highlight [result]="items1.budgetKER| number
                                                            : '1.2-2'">
                                                                        </ngb-highlight>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row justify-content-md-between align-items-md-center mt-2">
                                        <div class="col-sm-12 col-md-5">
                                            <div class="dataTables_info mb-2" id="tickets-table_info" role="status"
                                                aria-live="polite">
                                                Showing
                                                {{startIndex}} to
                                                {{endIndex}} of {{totalRecords}}
                                                entries
                                            </div>
                                        </div>
                                        <!-- Pagination -->
                                        <div class="col-sm-12 col-md-5">
                                            <div class="text-md-right float-md-end pagination-rounded">
                                                <ngb-pagination [collectionSize]="totalRecords" [(page)]="page"
                                                    [pageSize]="pageSize" [maxSize]="5" [rotate]="true"
                                                    [boundaryLinks]="true" (pageChange)="pageChange($event)">
                                                </ngb-pagination>
                                            </div>
                                        </div>
                                        <!-- End Pagination -->
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="row">&nbsp;</div>

                    <div id="dashboardBarLineChartCpoPk"></div>
                    
                    <div class="row">
                        <button class="btn btn-primary mo-mb-2 ms-1" type="button"
                            (click)="millProductivityCpoPkChartDetailsCollapsed = !millProductivityCpoPkChartDetailsCollapsed">
                            Show Chart Details
                        </button>
                        <div class="collapse" [ngbCollapse]="millProductivityCpoPkChartDetailsCollapsed">
                            <div class="card card-body mb-0">

                                <div class="card-body">
                                    <div class="row mb-md-2">
                                        <div class="col-sm-12 col-md-9 col-lg-10">
                                            <div class="dataTables_length table-responsive">
                                                <label class="d-inline-flex align-items-center">Show
                                                    <select name="tickets-table_length" aria-controls="tickets-table"
                                                        name="pageSize" [(ngModel)]="pageSize"
                                                        class="form-control form-control-sm mx-2"
                                                        (change)="pageSizeChange($event)">
                                                        <option [ngValue]="10">10</option>
                                                        <option [ngValue]="25">25</option>
                                                        <option [ngValue]="50">50</option>
                                                        <option [ngValue]="100">100</option>
                                                    </select> entries</label>
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                    <div class="table-responsive">
                                        <table id="basic-datatable"
                                            class="table table-bordered dt-responsive nowrap no-footer dtr-inline">
                                            <thead class="">
                                                <tr>
                                                    <th></th>
                                                    <th>{{SubChartLabel}}</th>
                                                    <th>CPO Total</th>
                                                    <th>PK Total</th>
                                                    <th>Budget CPO Total</th>
                                                    <th>Budget PK Total</th>
                                                </tr>
                                            </thead>
                                            <tbody *ngFor="let items of millProductivityCpoPkChartData;let i = index">
                                                <tr>
                                                    <td align="center">
                                                        <a class="expand-row" (click)="chartDetailsDetails(i)">
                                                            +
                                                        </a>
                                                    </td>
                                                    <td>
                                                        <ngb-highlight [result]="items.header"></ngb-highlight>
                                                    </td>
                                                    <td>
                                                        <ngb-highlight [result]="items.cpoTotal| number
                                                        : '1.2-2'">
                                                        </ngb-highlight>
                                                    </td>
                                                    <td>
                                                        <ngb-highlight [result]="items.pkTotal| number
                                                        : '1.2-2'">
                                                        </ngb-highlight>
                                                    </td>
                                                    <td>
                                                        <ngb-highlight [result]="items.budgetCPOTotal| number
                                            : '1.2-2'">
                                                        </ngb-highlight>
                                                    </td>
                                                    <td>
                                                        <ngb-highlight [result]="items.budgetPKTotal| number
                                            : '1.2-2'">
                                                        </ngb-highlight>
                                                    </td>
                                                    
                                                </tr>
                                                <tr *ngIf="showChartDetailsDetails[i]" class="sub-table no-bg">

                                                    <td align="center"> </td>
                                                    <td colspan="15" class="p-0">
                                                        <table class="table mb-0 table-striped">
                                                            <thead class="bg-dark text-white">
                                                                <tr>
                                                                    <th>OU</th>
                                                                    <th>CPO</th>
                                                                    <th>PK</th>
                                                                    <th>Budget CPO</th>
                                                                    <th>Budget PK</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr *ngFor="let items1 of items.tablesItems;let e = index">
                                                                    <td>
                                                                        <ngb-highlight [result]="items1.title">
                                                                        </ngb-highlight>
                                                                    </td>
                                                                    <td>
                                                                        <ngb-highlight [result]="items1.cpo| number
                                                            : '1.2-2'">
                                                                        </ngb-highlight>
                                                                    </td>
                                                                    <td>
                                                                        <ngb-highlight [result]="items1.pk| number
                                                            : '1.2-2'">
                                                                        </ngb-highlight>
                                                                    </td>
                                                                    <td>
                                                                        <ngb-highlight [result]="items1.budgetCPO| number
                                                            : '1.2-2'">
                                                                        </ngb-highlight>
                                                                    </td>
                                                                    <td>
                                                                        <ngb-highlight [result]="items1.budgetPK| number
                                                            : '1.2-2'">
                                                                        </ngb-highlight>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row justify-content-md-between align-items-md-center mt-2">
                                        <div class="col-sm-12 col-md-5">
                                            <div class="dataTables_info mb-2" id="tickets-table_info" role="status"
                                                aria-live="polite">
                                                Showing
                                                {{startIndex}} to
                                                {{endIndex}} of {{totalRecords}}
                                                entries
                                            </div>
                                        </div>
                                        <!-- Pagination -->
                                        <div class="col-sm-12 col-md-5">
                                            <div class="text-md-right float-md-end pagination-rounded">
                                                <ngb-pagination [collectionSize]="totalRecords" [(page)]="page"
                                                    [pageSize]="pageSize" [maxSize]="5" [rotate]="true"
                                                    [boundaryLinks]="true" (pageChange)="pageChange($event)">
                                                </ngb-pagination>
                                            </div>
                                        </div>
                                        <!-- End Pagination -->
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="row">&nbsp;</div>

                    <div id="dashboardBarLineChartFfb"></div>
                    
                    <div class="row">
                        <button class="btn btn-primary mo-mb-2 ms-1" type="button"
                            (click)="millProductivityFfbChartDetailsCollapsed = !millProductivityFfbChartDetailsCollapsed">
                            Show Chart Details
                        </button>
                        <div class="collapse" [ngbCollapse]="millProductivityFfbChartDetailsCollapsed">
                            <div class="card card-body mb-0">

                                <div class="card-body">
                                    <div class="row mb-md-2">
                                        <div class="col-sm-12 col-md-9 col-lg-10">
                                            <div class="dataTables_length table-responsive">
                                                <label class="d-inline-flex align-items-center">Show
                                                    <select name="tickets-table_length" aria-controls="tickets-table"
                                                        name="pageSize" [(ngModel)]="pageSize"
                                                        class="form-control form-control-sm mx-2"
                                                        (change)="pageSizeChange($event)">
                                                        <option [ngValue]="10">10</option>
                                                        <option [ngValue]="25">25</option>
                                                        <option [ngValue]="50">50</option>
                                                        <option [ngValue]="100">100</option>
                                                    </select> entries</label>
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                    <div class="table-responsive">
                                        <table id="basic-datatable"
                                            class="table table-bordered dt-responsive nowrap no-footer dtr-inline">
                                            <thead class="">
                                                <tr>
                                                    <th></th>
                                                    <th>{{SubChartLabel}}</th>
                                                    <th>CPO Total</th>
                                                    <th>PK Total</th>
                                                    <th>FFB Processed Total</th>
                                                    <th>FFB Received Total</th>
                                                    <th>OER Total</th>
                                                    <th>KER Total</th>
                                                    <th>Budget FFB Processed Total</th>
                                                </tr>
                                            </thead>
                                            <tbody *ngFor="let items of millProductivityFfbChartData;let i = index">
                                                <tr>
                                                    <td align="center">
                                                        <a class="expand-row" (click)="chartDetailsDetails(i)">
                                                            +
                                                        </a>
                                                    </td>
                                                    <td>
                                                        <ngb-highlight [result]="items.header"></ngb-highlight>
                                                    </td>
                                                    <td>
                                                        <ngb-highlight [result]="items.cpoTotal| number
                                                        : '1.2-2'">
                                                        </ngb-highlight>
                                                    </td>
                                                    <td>
                                                        <ngb-highlight [result]="items.pkTotal| number
                                                        : '1.2-2'">
                                                        </ngb-highlight>
                                                    </td>
                                                    <td>
                                                        <ngb-highlight [result]="items.ffbprcsTotal| number
                                                        : '1.2-2'">
                                                        </ngb-highlight>
                                                    </td>
                                                    <td>
                                                        <ngb-highlight [result]="items.ffbrecTotal| number
                                                        : '1.2-2'">
                                                        </ngb-highlight>
                                                    </td>
                                                    <td>
                                                        <ngb-highlight [result]="items.oerTotal| number
                                                        : '1.2-2'">
                                                        </ngb-highlight>
                                                    </td>
                                                    <td>
                                                        <ngb-highlight [result]="items.kerTotal| number
                                                        : '1.2-2'">
                                                        </ngb-highlight>
                                                    </td>
                                                    <td>
                                                        <ngb-highlight [result]="items.budgetFFBPRCSTotal| number
                                                        : '1.2-2'">
                                                        </ngb-highlight>
                                                    </td>
                                                </tr>
                                                <tr *ngIf="showChartDetailsDetails[i]" class="sub-table no-bg">
                                                    <td colspan="15" class="p-0">
                                                        <table class="table mb-0 table-striped">
                                                            <thead class="bg-dark text-white">
                                                                <tr>
                                                                    <th>OU</th>
                                                                    <th>CPO</th>
                                                                    <th>PK</th>
                                                                    <th>FFB Processed</th>
                                                                    <th>FFB Received</th>
                                                                    <th>OER (%)</th>
                                                                    <th>KER (%)</th>
                                                                    <th>Budget FFB Processed</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr *ngFor="let items1 of items.tablesItems;let e = index">
                                                                    <td>
                                                                        <ngb-highlight [result]="items1.title">
                                                                        </ngb-highlight>
                                                                    </td>
                                                                    <td>
                                                                        <ngb-highlight [result]="items1.cpo| number
                                                            : '1.2-2'">
                                                                        </ngb-highlight>
                                                                    </td>
                                                                    <td>
                                                                        <ngb-highlight [result]="items1.pk| number
                                                            : '1.2-2'">
                                                                        </ngb-highlight>
                                                                    </td>
                                                                    <td>
                                                                        <ngb-highlight [result]="items1.ffbProcess| number
                                                            : '1.2-2'">
                                                                        </ngb-highlight>
                                                                    </td>
                                                                    <td>
                                                                        <ngb-highlight [result]="items1.ffbReceived| number
                                                            : '1.2-2'">
                                                                        </ngb-highlight>
                                                                    </td>
                                                                    <td>
                                                                        <ngb-highlight [result]="items1.oer| number
                                                            : '1.2-2'">
                                                                        </ngb-highlight>
                                                                    </td>
                                                                    <td>
                                                                        <ngb-highlight [result]="items1.ker| number
                                                            : '1.2-2'">
                                                                        </ngb-highlight>
                                                                    </td>
                                                                    <td>
                                                                        <ngb-highlight [result]="items1.budgetFFBProcess| number
                                                            : '1.2-2'">
                                                                        </ngb-highlight>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row justify-content-md-between align-items-md-center mt-2">
                                        <div class="col-sm-12 col-md-5">
                                            <div class="dataTables_info mb-2" id="tickets-table_info" role="status"
                                                aria-live="polite">
                                                Showing
                                                {{startIndex}} to
                                                {{endIndex}} of {{totalRecords}}
                                                entries
                                            </div>
                                        </div>
                                        <!-- Pagination -->
                                        <div class="col-sm-12 col-md-5">
                                            <div class="text-md-right float-md-end pagination-rounded">
                                                <ngb-pagination [collectionSize]="totalRecords" [(page)]="page"
                                                    [pageSize]="pageSize" [maxSize]="5" [rotate]="true"
                                                    [boundaryLinks]="true" (pageChange)="pageChange($event)">
                                                </ngb-pagination>
                                            </div>
                                        </div>
                                        <!-- End Pagination -->
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>

            <div *ngIf="!compareData">
                <div class="row">
                    <div class="col-lg-4 col-md-6 col-sm-12" *ngIf="groupingType==='day'">
                        <div class="card ext-card">
                            <div class="card-body">
                                <p class="text-muted mb-4 font-size-20"
                                    [class.selected-grouping]="groupingType ==='day'"><i
                                        class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>Oil Extraction Rate (OER)</p>

                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-12">
                                        <div>
                                            <h5>{{dailyMt | number : '1.2-2'}} %</h5>
                                            <p class="text-muted text-truncate mb-0">OER Budget: {{dailyBudget | number
                                                : '1.2-2'}} %</p>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12 variance-container">
                                        <div class="row">
                                            <div class="d-flex">
                                                <!-- <span class="text-truncate">Var: </span><span class="badge font-size-12"
                                                    [ngClass]="dailyVarMt >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                    {{dailyVarMt | number : '1.2-2'}} mt</span> -->
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="d-flex">
                                                <span class="text-truncate">Var %: </span><span class="badge font-size-12"
                                                    [ngClass]="dailyVarPer >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                    {{dailyVarPer | number : '1.2-2'}} %</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12" *ngIf="groupingType==='day'">
                        <div class="card ext-card">
                            <div class="card-body">
                                <p class="text-muted mb-4 font-size-20"
                                    [class.selected-grouping]="groupingType ==='day'"><i
                                        class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>Kernel Extraction Rate (KER)</p>

                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-12">
                                        <div>
                                            <h5>{{dailyKER | number : '1.2-2'}} %</h5>
                                            <p class="text-muted text-truncate mb-0">KER Budget: {{dailyBudgetKER | number
                                                : '1.2-2'}} %</p>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12 variance-container">
                                        <div class="row">
                                            <div class="d-flex">
                                                <!-- <span class="text-truncate">Var: </span><span class="badge font-size-12"
                                                    [ngClass]="dailyVarMt >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                    {{dailyVarMt | number : '1.2-2'}} mt</span> -->
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="d-flex">
                                                <span class="text-truncate">Var %: </span><span class="badge font-size-12"
                                                    [ngClass]="varianceKER >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                    {{varianceKER | number : '1.2-2'}} %</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12" *ngIf="groupingType==='day'">
                        <div class="card ext-card">
                            <div class="card-body">
                                <p class="text-muted mb-4 font-size-20"
                                    [class.selected-grouping]="groupingType ==='day'"><i
                                        class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>Fresh Fruit Bunch (FFB)</p>
                                <div class="row">
                                    <div class="col-lg-12 col-md-12 col-sm-12">
                                        <div>
                                            <h5>FFB Processed: {{dailyFfbPrcss | number : '1.2-2'}} mt</h5>
                                            <h5>FFB Received: {{dailyFfbRecv | number : '1.2-2'}} mt</h5>
                                            <p style="padding-left: 50px;" class="text-muted text-truncate mb-0">Certified: {{cert_ffbreceived | number
                                                : '1.2-2'}} mt ({{cert_ffbreceivedpercent}}%)</p>
                                            <p style="padding-left: 50px;" class="text-muted text-truncate mb-0">Non-Certified: {{noncert_ffbreceived | number
                                                    : '1.2-2'}} mt ({{noncert_ffbreceivedpercent}}%)</p>
                                            <h5>FFB Balance: <span [ngClass]="dailyFfbBal >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                            {{dailyFfbBal | number : '1.2-2'}} mt</span></h5>
                                        </div>
                                    </div>
                                    <!-- <div class="col-lg-6 col-md-6 col-sm-12 variance-container">
                                        <div class="row">
                                            <div class="d-flex">
                                                <span class="text-truncate">FFB Balance: </span><span class="badge font-size-12"
                                                    [ngClass]="dailyFfbBal >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                    {{dailyFfbBal | number : '1.2-2'}} mt</span>
                                            </div>
                                        </div>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12" *ngIf="groupingType==='day'">
                        <div class="card ext-card">
                            <div class="card-body">
                                <p class="text-muted mb-4 font-size-20"
                                    [class.selected-grouping]="groupingType ==='day'"><i
                                        class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>Crude Palm Oil (CPO)</p>

                                <div class="row">
                                    <div class="col-lg-12 col-md-12 col-sm-12">
                                        <div>
                                            <h5>CPO Production: {{dailyCpoProd | number : '1.2-2'}} mt</h5>
                                            <p style="padding-left: 50px;"class="text-muted text-truncate mb-0"> Certified: {{cert_CPOProduction | number
                                                : '1.2-2'}} mt</p>
                                            <p style="padding-left: 50px;"class="text-muted text-truncate mb-0">Non-Certified: {{noncert_CPOProduction | number
                                                : '1.2-2'}} mt</p>
                                            <h5>CPO Balance: {{dailyCpoBal | number : '1.2-2'}} mt</h5>
                                            <p style="padding-left: 50px;"class="text-muted text-truncate mb-0"> Certified: {{cert_CPOBalance | number
                                                : '1.2-2'}} mt</p>
                                            <p style="padding-left: 50px;"class="text-muted text-truncate mb-0">Non-Certified: {{noncert_CPOBalance | number
                                                : '1.2-2'}} mt</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12" *ngIf="groupingType==='day'">
                        <div class="card ext-card">
                            <div class="card-body">
                                <p class="text-muted mb-4 font-size-20"
                                    [class.selected-grouping]="groupingType ==='day'"><i
                                        class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>Palm Kernel (PK)</p>

                                <div class="row">
                                    <div class="col-lg-12 col-md-12 col-sm-12">
                                        <div>
                                            <h5>PK Production: {{dailyPkProd | number : '1.2-2'}} mt</h5>
                                            <p style="padding-left: 50px;"class="text-muted text-truncate mb-0">Certified: {{cert_PKProduction | number
                                            : '1.2-2'}} mt</p>
                                            <p style="padding-left: 50px;"class="text-muted text-truncate mb-0">Non-Certified: {{noncert_PKProduction | number
                                            : '1.2-2'}} mt</p>
                                            <h5>PK Balance: {{dailyPkBal | number : '1.2-2'}} mt</h5>
                                            <p style="padding-left: 50px;"class="text-muted text-truncate mb-0">Certified: {{cert_PKBalance | number
                                            : '1.2-2'}} mt</p>
                                            <p style="padding-left: 50px;"class="text-muted text-truncate mb-0">Non-Certified: {{noncert_PKBalance | number
                                            : '1.2-2'}} mt</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12" *ngIf="groupingType==='day'"></div>
                    <div class="col-lg-4 col-md-6 col-sm-12" *ngIf="groupingType==='day'">
                        <div class="card ext-card">
                            <div class="card-body">
                                <p class="text-muted mb-4 font-size-20"
                                    [class.selected-grouping]="groupingType ==='day'"><i
                                        class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>Storage Tank (ST) &nbsp; {{totalST | number : '1.2-2'}}</p>
                                    <div class="row" *ngIf="!ismultipleou">
                                        <table id="basic-datatable"
                                        class="table table-bordered dt-responsive nowrap no-footer dtr-inline">
                                        <thead style="text-align:center">
                                            <tr>
                                                <th>Tank</th>
                                                <th>MT</th>
                                                <th>FFA%</th>
                                                <th>DOBI%</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr style="text-align:center">
                                               <td style="text-align:center">
                                                <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:center;text-align:center" *ngFor="let Stmill of StMillList">
                                                    <h6>{{Stmill.name}}</h6>
                                                </div>
                                               </td>
                                               <td>
                                                <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:right;text-align:right"*ngFor="let Stmill of StMillList">
                                                    <h6>{{Stmill.mt | number : '1.2-2'}}</h6>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:right;text-align:right"*ngFor="let Stmill of StMillList">
                                                    <h6>{{Stmill.ffa | number : '1.2-2'}}</h6>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12"style="display: flex;justify-content:right;text-align:right" *ngFor="let Stmill of StMillList">
                                                    <h6> {{Stmill.dobi | number : '1.2-2'}}</h6>
                                                </div>
                                            </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                        
                                    </div>
                                    <div class="row"*ngIf="ismultipleou">
                                        <div class="card-padding-bottom col-lg-6 col-md-6 col-sm-12" *ngFor="let Stmill of StMillList">
                                            <h5 class="text-muted text-truncate mb-0">{{Stmill.name}}: {{Stmill.mt | number : '1.2-2'}} mt</h5> 
                                        </div>
                                    </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12" *ngIf="groupingType==='day'">
                        <div class="card ext-card">
                            <div class="card-body">
                                <p class="text-muted mb-4 font-size-20"><i
                                        class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>Kernel Bunker (KB)
                                </p>
                                <div class="row">
                                    <div class="col-12" style="display: flex; justify-content:center;">
                                        <div>
                                            <h5 class="font-size-20">{{kernalBunker | number : '1.2-2'}} mt</h5>
                                        </div>
                                    </div>
                                </div>
                                <br />
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12" *ngIf="groupingType==='day'"></div>
                    <div class="col-lg-4 col-md-6 col-sm-12" *ngIf="groupingType==='day'">
                        <div class="card ext-card">
                            <div class="card-body">
                                <p class="text-muted mb-4 font-size-20"
                                    [class.selected-grouping]="groupingType ==='day'"><i
                                        class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>Despatch Tank (DT)&nbsp;{{totalDT | number : '1.2-2'}}</p>
                                    <div class="row"*ngIf="!ismultipleou">
                                        <table id="basic-datatable"
                                        class="table table-bordered dt-responsive nowrap no-footer dtr-inline">
                                        <thead style="text-align:center">
                                            <tr>
                                                <th>Tank</th>
                                                <th>MT</th>
                                                <th>FFA%</th>
                                                <th>DOBI%</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                               <td>
                                                <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:center;text-align:center" *ngFor="let Dtmill of DtMillList">
                                                    <h6 style="display: flex;justify-content:center;text-align:center">{{Dtmill.name}}</h6> 
                                                </div>
                                               </td>
                                               <td>
                                                <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12"style="display: flex;justify-content:right;text-align:right" *ngFor="let Dtmill of DtMillList">
                                                    <h6 style="display: flex;justify-content:center;text-align:center">{{Dtmill.mt | number : '1.2-2'}}</h6> 
                                                </div>
                                            </td>
                                            <td>
                                                <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12"style="display: flex;justify-content:right;text-align:right" *ngFor="let Dtmill of DtMillList">
                                                    <h6 style="display: flex;justify-content:center;text-align:center">{{Dtmill.ffa | number : '1.2-2'}}</h6> 
                                                </div>
                                            </td>
                                            <td >
                                                <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:right;text-align:right" *ngFor="let Dtmill of DtMillList">
                                                    <h6 style="display: flex;justify-content:center;text-align:center">{{Dtmill.dobi | number : '1.2-2'}}</h6> 
                                                </div>
                                            </td>
                                            </tr>
                                        </tbody>
                                      </table>
                                       
                                    </div>
                                    <div class="row"*ngIf="ismultipleou">
                                        <div class="card-padding-bottom col-lg-6 col-md-6 col-sm-12" *ngFor="let Dtmill of DtMillList">
                                            <h5 class="text-muted text-truncate mb-0">{{Dtmill.name}}: {{Dtmill.mt | number : '1.2-2'}} mt</h5> 
                                        </div>
                                    </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12" *ngIf="groupingType==='month'">
                        <div class="card ext-card">
                            <div class="card-body">
                                <p class="text-muted mb-4 font-size-20"
                                    [class.selected-grouping]="groupingType ==='month'"><i
                                        class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>Oil Extraction Rate (OER)</p>

                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-12">
                                        <div>
                                            <h5>{{dailyMt | number : '1.2-2'}} %</h5>
                                            <p class="text-muted text-truncate mb-0">OER Budget: {{dailyBudget | number
                                                : '1.2-2'}} %</p>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12 variance-container">
                                        <div class="row">
                                            <div class="d-flex">
                                                <!-- <span class="text-truncate">Var: </span><span class="badge font-size-12"
                                                    [ngClass]="dailyVarMt >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                    {{dailyVarMt | number : '1.2-2'}} mt</span> -->
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="d-flex">
                                                <span class="text-truncate">Var %: </span><span class="badge font-size-12"
                                                    [ngClass]="dailyVarPer >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                    {{dailyVarPer | number : '1.2-2'}} %</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>  
                    <div class="col-lg-4 col-md-6 col-sm-12" *ngIf="groupingType==='month'">
                        <div class="card ext-card">
                            <div class="card-body">
                                <p class="text-muted mb-4 font-size-20"
                                    [class.selected-grouping]="groupingType ==='month'"><i
                                        class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>Kernel Extraction Rate (KER)</p>

                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-12">
                                        <div>
                                            <h5>{{dailyKER | number : '1.2-2'}} %</h5>
                                            <p class="text-muted text-truncate mb-0">KER Budget: {{dailyBudgetKER | number
                                                : '1.2-2'}} %</p>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12 variance-container">
                                        <div class="row">
                                            <div class="d-flex">
                                                <!-- <span class="text-truncate">Var: </span><span class="badge font-size-12"
                                                    [ngClass]="dailyVarMt >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                    {{dailyVarMt | number : '1.2-2'}} mt</span> -->
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="d-flex">
                                                <span class="text-truncate">Var %: </span><span class="badge font-size-12"
                                                    [ngClass]="varianceKER >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                    {{varianceKER | number : '1.2-2'}} %</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12" *ngIf="groupingType==='month'">
                        <div class="card ext-card">
                            <div class="card-body">
                                <p class="text-muted mb-4 font-size-20"
                                    [class.selected-grouping]="groupingType ==='month'"><i
                                        class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>Fresh Fruit Bunch (FFB)</p>
                                        <div class="row">
                                            <div class="col-lg-12 col-md-12 col-sm-12">
                                                <div>
                                                    <h5>FFB Processed: {{dailyFfbPrcss | number : '1.2-2'}} mt</h5>
                                                    <h5>FFB Received: {{dailyFfbRecv | number : '1.2-2'}} mt</h5>
                                                    <p style="padding-left: 50px;" class="text-muted text-truncate mb-0">Certified: {{cert_ffbreceived | number
                                                        : '1.2-2'}} mt ({{cert_ffbreceivedpercent}}%)</p>
                                                    <p style="padding-left: 50px;" class="text-muted text-truncate mb-0">Non-Certified: {{noncert_ffbreceived | number
                                                            : '1.2-2'}} mt ({{noncert_ffbreceivedpercent}}%)</p>                                                            
                                                    <h5>FFB Balance: <span [ngClass]="dailyFfbBal >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{dailyFfbBal | number : '1.2-2'}} mt</span></h5>
                                                </div>
                                            </div>
                                            <!-- <div class="col-lg-6 col-md-6 col-sm-12 variance-container">
                                                <div class="row">
                                                    <div class="d-flex">
                                                        <span class="text-truncate">FFB Balance: </span><span class="badge font-size-12"
                                                            [ngClass]="dailyFfbBal >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                            {{dailyFfbBal | number : '1.2-2'}} mt</span>
                                                    </div>
                                                </div>
                                            </div> -->
                                        </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12" *ngIf="groupingType==='month'">
                        <div class="card ext-card">
                            <div class="card-body">
                                <p class="text-muted mb-4 font-size-20"
                                    [class.selected-grouping]="groupingType ==='month'"><i
                                        class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>Crude Palm Oil (CPO)</p>
                                        <div class="row">
                                            <div class="col-lg-12 col-md-12 col-sm-12">
                                                <div>
                                                    <h5>CPO Production: {{dailyCpoProd | number : '1.2-2'}} mt</h5>
                                                    <p style="padding-left: 50px;"class="text-muted text-truncate mb-0"> Certified: {{cert_CPOProduction | number
                                                        : '1.2-2'}} mt</p>
                                                    <p style="padding-left: 50px;"class="text-muted text-truncate mb-0">Non-Certified: {{noncert_CPOProduction | number
                                                        : '1.2-2'}} mt</p>
                                                    <h5>CPO Balance: {{dailyCpoBal | number : '1.2-2'}} mt</h5>
                                                    <p style="padding-left: 50px;"class="text-muted text-truncate mb-0"> Certified: {{cert_CPOBalance | number
                                                        : '1.2-2'}} mt</p>
                                                    <p style="padding-left: 50px;"class="text-muted text-truncate mb-0">Non-Certified: {{noncert_CPOBalance | number
                                                        : '1.2-2'}} mt</p>
                                                </div>
                                            </div>
                                        </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12" *ngIf="groupingType==='month'">
                        <div class="card ext-card">
                            <div class="card-body">
                                <p class="text-muted mb-4 font-size-20"
                                    [class.selected-grouping]="groupingType ==='month'"><i
                                        class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>Palm Kernel (PK)</p>
                                        <div class="row">
                                            <div class="col-lg-12 col-md-12 col-sm-12">
                                                <div>
                                                    <h5>PK Production: {{dailyPkProd | number : '1.2-2'}} mt</h5>
                                                    <p style="padding-left: 50px;"class="text-muted text-truncate mb-0">Certified: {{cert_PKProduction | number
                                                    : '1.2-2'}} mt</p>
                                                    <p style="padding-left: 50px;"class="text-muted text-truncate mb-0">Non-Certified: {{noncert_PKProduction | number
                                                    : '1.2-2'}} mt</p>
                                                    <h5>PK Balance: {{dailyPkBal | number : '1.2-2'}} mt</h5>
                                                    <p style="padding-left: 50px;"class="text-muted text-truncate mb-0">Certified: {{cert_PKBalance | number
                                                    : '1.2-2'}} mt</p>
                                                    <p style="padding-left: 50px;"class="text-muted text-truncate mb-0">Non-Certified: {{noncert_PKBalance | number
                                                    : '1.2-2'}} mt</p>
                                                </div>
                                            </div>
                                        </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12" *ngIf="groupingType==='month'"></div>
                    <div class="col-lg-4 col-md-6 col-sm-12" *ngIf="groupingType==='month'">
                        <div class="card ext-card">
                            <div class="card-body">
                                <p class="text-muted mb-4 font-size-20"
                                    [class.selected-grouping]="groupingType ==='month'"><i
                                        class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>Storage Tank (ST) &nbsp; {{totalST | number : '1.2-2'}}</p>
                                    <div class="row" *ngIf="!ismultipleou">
                                        <table id="basic-datatable"
                                        class="table table-bordered dt-responsive nowrap no-footer dtr-inline">
                                        <thead style="text-align:center">
                                            <tr>
                                                <th>Tank</th>
                                                <th>MT</th>
                                                <th>FFA%</th>
                                                <th>DOBI%</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                               <td>
                                                <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:center;text-align:center" *ngFor="let Stmill of StMillList">
                                                    <h6>{{Stmill.name}}</h6>
                                                </div>
                                               </td>
                                               <td>
                                                <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:right;text-align:right"*ngFor="let Stmill of StMillList">
                                                    <h6>{{Stmill.mt | number : '1.2-2'}}</h6>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:right;text-align:right"*ngFor="let Stmill of StMillList">
                                                    <h6>{{Stmill.ffa | number : '1.2-2'}}</h6>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12"style="display: flex;justify-content:right;text-align:right" *ngFor="let Stmill of StMillList">
                                                    <h6> {{Stmill.dobi | number : '1.2-2'}}</h6>
                                                </div>
                                            </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    </div>
                                    <div class="row"*ngIf="ismultipleou">
                                        <div class="card-padding-bottom col-lg-6 col-md-6 col-sm-12" *ngFor="let Stmill of StMillList">
                                            <h5 class="text-muted text-truncate mb-0">{{Stmill.name}}: {{Stmill.mt | number : '1.2-2'}} mt</h5> 
                                        </div>
                                    </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12" *ngIf="groupingType==='month'">
                        <div class="card ext-card">
                            <div class="card-body">
                                <p class="text-muted mb-4 font-size-20"><i
                                        class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>Kernel Bunker (KB)
                                </p>
                                <div class="row">
                                    <div class="col-12" style="display: flex; justify-content:center;">
                                        <div>
                                            <h5 class="font-size-20">{{kernalBunker | number : '1.2-2'}} mt</h5>
                                        </div>
                                    </div>
                                </div>
                                <br />
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12" *ngIf="groupingType==='month'"></div>
                    <div class="col-lg-4 col-md-6 col-sm-12" *ngIf="groupingType==='month'">
                        <div class="card ext-card">
                            <div class="card-body">
                                <p class="text-muted mb-4 font-size-20"
                                    [class.selected-grouping]="groupingType ==='month'"><i
                                        class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>Despatch Tank (DT)&nbsp;{{totalDT | number : '1.2-2'}}</p>
                                        <div class="row"*ngIf="!ismultipleou">
                                            <table id="basic-datatable"
                                            class="table table-bordered dt-responsive nowrap no-footer dtr-inline">
                                            <thead style="text-align:center">
                                                <tr>
                                                    <th>Tank</th>
                                                    <th>MT</th>
                                                    <th>FFA%</th>
                                                    <th>DOBI%</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                   <td>
                                                    <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:center;text-align:center" *ngFor="let Dtmill of DtMillList">
                                                        <h6 style="display: flex;justify-content:center;text-align:center">{{Dtmill.name}}</h6> 
                                                    </div>
                                                   </td>
                                                   <td>
                                                    <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12"style="display: flex;justify-content:right;text-align:right" *ngFor="let Dtmill of DtMillList">
                                                        <h6 style="display: flex;justify-content:center;text-align:center">{{Dtmill.mt | number : '1.2-2'}}</h6> 
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12"style="display: flex;justify-content:right;text-align:right" *ngFor="let Dtmill of DtMillList">
                                                        <h6 style="display: flex;justify-content:center;text-align:center">{{Dtmill.ffa | number : '1.2-2'}}</h6> 
                                                    </div>
                                                </td>
                                                <td >
                                                    <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:right;text-align:right" *ngFor="let Dtmill of DtMillList">
                                                        <h6 style="display: flex;justify-content:center;text-align:center">{{Dtmill.dobi | number : '1.2-2'}}</h6> 
                                                    </div>
                                                </td>
                                                </tr>
                                            </tbody>
                                          </table>
                                           
                                        </div>
                                        <div class="row"*ngIf="ismultipleou">
                                            <div class="card-padding-bottom col-lg-6 col-md-6 col-sm-12" *ngFor="let Dtmill of DtMillList">
                                                <h5 class="text-muted text-truncate mb-0">{{Dtmill.name}}: {{Dtmill.mt | number : '1.2-2'}} mt</h5> 
                                            </div>
                                        </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12"
                        *ngIf="groupingType==='year'">
                        <div class="card ext-card">
                            <div class="card-body">
                                <p class="text-muted mb-4 font-size-20"
                                    [class.selected-grouping]="groupingType ==='year'">
                                    <i class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{oerText}}
                                </p>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-12">
                                        <div>
                                            <h5>{{dailyMt | number : '1.2-2'}} %</h5>
                                            <p class="text-muted text-truncate mb-0">OER Budget: {{dailyBudget | number
                                                : '1.2-2'}} %</p>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12 variance-container">
                                        <div class="row">
                                            <div class="d-flex">
                                                <span class="text-truncate">Var %: </span><span class="badge font-size-12"
                                                    [ngClass]="dailyVarPer >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                    {{dailyVarPer | number : '1.2-2'}} %</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12"
                        *ngIf="groupingType ==='range'|| groupingType ==='quarter'">
                        <div class="card ext-card">
                            <div class="card-body">
                                <p class="text-muted mb-4 font-size-20"
                                    [class.selected-grouping]="groupingType ==='range'|| groupingType ==='quarter'">
                                    <i class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{oerText}}
                                </p>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-12">
                                        <div>
                                            <h5>OER: {{dailyMt | number : '1.2-2'}} %</h5>
                                            <p class="text-muted text-truncate mb-0">Budget: {{dailyBudget | number
                                                : '1.2-2'}} %</p>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12 variance-container">
                                        <div class="row">
                                            <div class="d-flex">
                                                <span class="text-truncate">Var: </span><span class="badge font-size-12"
                                                    [ngClass]="dailyVarPer >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                    {{dailyVarPer | number : '1.2-2'}} %</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12"
                        *ngIf="groupingType==='year'">
                        <div class="card ext-card">
                            <div class="card-body">
                                <p class="text-muted mb-4 font-size-20"
                                    [class.selected-grouping]="groupingType ==='year'">
                                    <i class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{kerText}}
                                </p>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-12">
                                        <div>
                                            <h5>{{dailyKER | number : '1.2-2'}} %</h5>
                                            <p class="text-muted text-truncate mb-0">KER Budget: {{dailyBudgetKER | number
                                                : '1.2-2'}} %</p>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12 variance-container">
                                        <div class="row">
                                            <div class="d-flex">
                                                <span class="text-truncate">Var %: </span><span class="badge font-size-12"
                                                    [ngClass]="varianceKER >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                    {{varianceKER | number : '1.2-2'}} %</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12"
                        *ngIf="groupingType ==='range'|| groupingType ==='quarter'">
                        <div class="card ext-card">
                            <div class="card-body">
                                <p class="text-muted mb-4 font-size-20"
                                    [class.selected-grouping]="groupingType ==='range'|| groupingType ==='quarter'">
                                    <i class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{kerText}}
                                </p>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-12">
                                        <div>
                                            <h5>KER: {{dailyKER | number : '1.2-2'}} %</h5>
                                            <p class="text-muted text-truncate mb-0">Budget: {{dailyBudgetKER | number
                                                : '1.2-2'}} %</p>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12 variance-container">
                                        <div class="row">
                                            <div class="d-flex">
                                                <span class="text-truncate">Var: </span><span class="badge font-size-12"
                                                    [ngClass]="varianceKER >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                    {{varianceKER | number : '1.2-2'}} %</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12" *ngIf="groupingType==='year' || groupingType ==='range'|| groupingType ==='quarter'">
                        <div class="card ext-card">
                            <div class="card-body">
                                <p class="text-muted mb-4 font-size-20"
                                [class.selected-grouping]="groupingType==='year' || groupingType ==='range'|| groupingType ==='quarter'"><i
                                        class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>Fresh Fruit Bunch (FFB)</p>
                                        <div class="row">
                                            <div class="col-lg-12 col-md-12 col-sm-12">
                                                <div>
                                                    <h5>FFB Processed: {{dailyFfbPrcss | number : '1.2-2'}} mt</h5>
                                                    <h5>FFB Received: {{dailyFfbRecv | number : '1.2-2'}} mt</h5>
                                                    <p style="padding-left: 50px;" class="text-muted text-truncate mb-0">Certified: {{cert_ffbreceived | number
                                                        : '1.2-2'}} mt ({{cert_ffbreceivedpercent}}%)</p>
                                                    <p style="padding-left: 50px;" class="text-muted text-truncate mb-0">Non-Certified: {{noncert_ffbreceived | number
                                                            : '1.2-2'}} mt ({{noncert_ffbreceivedpercent}}%)</p>                                                            
                                                    <h5>FFB Balance: <span [ngClass]="dailyFfbBal >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{dailyFfbBal | number : '1.2-2'}} mt</span></h5>
                                                </div>
                                            </div>
                                            <!-- <div class="col-lg-6 col-md-6 col-sm-12 variance-container">
                                                <div class="row">
                                                    <div class="d-flex">
                                                        <span class="text-truncate">FFB Balance: </span><span class="badge font-size-12"
                                                            [ngClass]="dailyFfbBal >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                            {{dailyFfbBal | number : '1.2-2'}} mt</span>
                                                    </div>
                                                </div>
                                            </div> -->
                                        </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12" *ngIf="groupingType==='year' || groupingType ==='range'|| groupingType ==='quarter'">
                        <div class="card ext-card">
                            <div class="card-body">
                                <p class="text-muted mb-4 font-size-20"
                                    [class.selected-grouping]="groupingType==='year' || groupingType ==='range'|| groupingType ==='quarter'"><i
                                        class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>Crude Palm Oil (CPO)</p>
                                        <div class="row">
                                            <div class="col-lg-12 col-md-12 col-sm-12">
                                                <div>
                                                    <h5>CPO Production: {{dailyCpoProd | number : '1.2-2'}} mt</h5>
                                                    <p style="padding-left: 50px;"class="text-muted text-truncate mb-0"> Certified: {{cert_CPOProduction | number
                                                        : '1.2-2'}} mt</p>
                                                    <p style="padding-left: 50px;"class="text-muted text-truncate mb-0">Non-Certified: {{noncert_CPOProduction | number
                                                        : '1.2-2'}} mt</p>
                                                    <h5>CPO Balance: {{dailyCpoBal | number : '1.2-2'}} mt</h5>
                                                    <p style="padding-left: 50px;"class="text-muted text-truncate mb-0"> Certified: {{cert_CPOBalance | number
                                                        : '1.2-2'}} mt</p>
                                                    <p style="padding-left: 50px;"class="text-muted text-truncate mb-0">Non-Certified: {{noncert_CPOBalance | number
                                                        : '1.2-2'}} mt</p>
                                                </div>
                                            </div>
                                        </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12" *ngIf="groupingType==='year' || groupingType ==='range'|| groupingType ==='quarter'">
                        <div class="card ext-card">
                            <div class="card-body">
                                <p class="text-muted mb-4 font-size-20"
                                    [class.selected-grouping]="groupingType==='year' || groupingType ==='range'|| groupingType ==='quarter'"><i
                                        class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>Palm Kernel (PK)</p>

                                        <div class="row">
                                            <div class="col-lg-12 col-md-12 col-sm-12">
                                                <div>
                                                    <h5>PK Production: {{dailyPkProd | number : '1.2-2'}} mt</h5>
                                                    <p style="padding-left: 50px;"class="text-muted text-truncate mb-0">Certified: {{cert_PKProduction | number
                                                    : '1.2-2'}} mt</p>
                                                    <p style="padding-left: 50px;"class="text-muted text-truncate mb-0">Non-Certified: {{noncert_PKProduction | number
                                                    : '1.2-2'}} mt</p>
                                                    <h5>PK Balance: {{dailyPkBal | number : '1.2-2'}} mt</h5>
                                                    <p style="padding-left: 50px;"class="text-muted text-truncate mb-0">Certified: {{cert_PKBalance | number
                                                    : '1.2-2'}} mt</p>
                                                    <p style="padding-left: 50px;"class="text-muted text-truncate mb-0">Non-Certified: {{noncert_PKBalance | number
                                                    : '1.2-2'}} mt</p>
                                                </div>
                                            </div>
                                        </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12" *ngIf="groupingType==='year' || groupingType ==='range'|| groupingType ==='quarter'"></div>
                    <div class="col-lg-4 col-md-6 col-sm-12" *ngIf="groupingType==='year' || groupingType ==='range'|| groupingType ==='quarter'">
                        <div class="card ext-card">
                            <div class="card-body">
                                <p class="text-muted mb-4 font-size-20"
                                    [class.selected-grouping]="groupingType ==='year' || groupingType ==='range'|| groupingType ==='quarter'"><i
                                        class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>Storage Tank (ST) &nbsp; {{totalST | number : '1.2-2'}}</p>
                                    <div class="row"*ngIf="!ismultipleou">
                                        <table id="basic-datatable"
                                        class="table table-bordered dt-responsive nowrap no-footer dtr-inline">
                                        <thead style="text-align:center">
                                            <tr>
                                                <th>Tank</th>
                                                <th>MT</th>
                                                <th>FFA%</th>
                                                <th>DOBI%</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                               <td>
                                                <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:center;text-align:center" *ngFor="let Stmill of StMillList">
                                                    <h6>{{Stmill.name}}</h6>
                                                </div>
                                               </td>
                                               <td>
                                                <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:right;text-align:right"*ngFor="let Stmill of StMillList">
                                                    <h6>{{Stmill.mt | number : '1.2-2'}}</h6>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:right;text-align:right"*ngFor="let Stmill of StMillList">
                                                    <h6>{{Stmill.ffa | number : '1.2-2'}}</h6>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12"style="display: flex;justify-content:right;text-align:right" *ngFor="let Stmill of StMillList">
                                                    <h6> {{Stmill.dobi | number : '1.2-2'}}</h6>
                                                </div>
                                            </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    </div>
                                    <div class="row"*ngIf="ismultipleou">
                                        <div class="card-padding-bottom col-lg-6 col-md-6 col-sm-12" *ngFor="let Stmill of StMillList">
                                            <h5 class="text-muted text-truncate mb-0">{{Stmill.name}}: {{Stmill.mt | number : '1.2-2'}} mt</h5> 
                                        </div>
                                    </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12" *ngIf="groupingType==='year' || groupingType ==='range'|| groupingType ==='quarter'">
                        <div class="card ext-card">
                            <div class="card-body">
                                <p class="text-muted mb-4 font-size-20"><i
                                        class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>Kernel Bunker (KB)
                                </p>
                                <div class="row">
                                    <div class="col-12" style="display: flex; justify-content:center;">
                                        <div>
                                            <h5 class="font-size-20">{{kernalBunker | number : '1.2-2'}} mt</h5>
                                        </div>
                                    </div>
                                </div>
                                <br />
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12" *ngIf="groupingType==='year' || groupingType ==='range'|| groupingType ==='quarter'"></div>
                    <div class="col-lg-4 col-md-6 col-sm-12" *ngIf="groupingType==='year' || groupingType ==='range'|| groupingType ==='quarter'">
                        <div class="card ext-card">
                            <div class="card-body">
                                <p class="text-muted mb-4 font-size-20"
                                    [class.selected-grouping]="groupingType==='year' || groupingType ==='range'|| groupingType ==='quarter'"><i
                                        class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>Despatch Tank (DT)&nbsp;{{totalDT | number : '1.2-2'}}</p>
                                        <div class="row"*ngIf="!ismultipleou">
                                            <table id="basic-datatable"
                                            class="table table-bordered dt-responsive nowrap no-footer dtr-inline">
                                            <thead style="text-align:center">
                                                <tr>
                                                    <th>Tank</th>
                                                    <th>MT</th>
                                                    <th>FFA%</th>
                                                    <th>DOBI%</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                   <td>
                                                    <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:center;text-align:center" *ngFor="let Dtmill of DtMillList">
                                                        <h6 style="display: flex;justify-content:center;text-align:center">{{Dtmill.name}}</h6> 
                                                    </div>
                                                   </td>
                                                   <td>
                                                    <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12"style="display: flex;justify-content:right;text-align:right" *ngFor="let Dtmill of DtMillList">
                                                        <h6 style="display: flex;justify-content:center;text-align:center">{{Dtmill.mt | number : '1.2-2'}}</h6> 
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12"style="display: flex;justify-content:right;text-align:right" *ngFor="let Dtmill of DtMillList">
                                                        <h6 style="display: flex;justify-content:center;text-align:center">{{Dtmill.ffa | number : '1.2-2'}}</h6> 
                                                    </div>
                                                </td>
                                                <td >
                                                    <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:right;text-align:right" *ngFor="let Dtmill of DtMillList">
                                                        <h6 style="display: flex;justify-content:center;text-align:center">{{Dtmill.dobi | number : '1.2-2'}}</h6> 
                                                    </div>
                                                </td>
                                                </tr>
                                            </tbody>
                                          </table>
                                           
                                        </div>
                                        <div class="row"*ngIf="ismultipleou">
                                            <div class="card-padding-bottom col-lg-6 col-md-6 col-sm-12" *ngFor="let Dtmill of DtMillList">
                                                <h5 class="text-muted text-truncate mb-0">{{Dtmill.name}}: {{Dtmill.mt | number : '1.2-2'}} mt</h5> 
                                            </div>
                                        </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="compareData">
                <div class="row">
                    <div class="col-6">

                        <div class="row offset-lg-4">
                            <div *ngIf="groupingType==='day' && compareData" class="col-12">
                                <label class="label">Date</label>
                                <input [(ngModel)]="compareDate1" (change)="compareDate1Change()" class="form-control"
                                    placeholder="dd/MM/yyyy" type="date">
                            </div>
                            
                            <div *ngIf="(groupingType==='month' || groupingType==='year' || groupingType==='range'|| groupingType==='quarter') && compareData"
                                class="col-12">
                                <label class="label">Year</label>
                                <ng-select [items]="years" bindValue="year" [(ngModel)]="compareYearSel1"
                                    (ngModelChange)="selYearChangeCom(true)">
                                </ng-select>
                            </div>

                            <div *ngIf="groupingType==='range' && compareData" class="col-12">
                                <label class="label">Month From (Year {{compareYearSel1}})</label>
                                <ng-select [items]="compareMonthsFrom1" bindValue="month" bindLabel="desc"
                                    [(ngModel)]="compareMonthFromSel1" (change)="selMonthFromCompareChange(true)">
                                </ng-select>
                            </div>

                            <div *ngIf="groupingType==='range' && compareData" class="col-12">
                                <label class="label">Month To (Year {{compareYearSel1}})</label>
                                <ng-select [items]="compareMonthsTo1" bindValue="month" bindLabel="desc"
                                    [(ngModel)]="compareMonthToSel1" (change)="compareDate1Change()">
                                </ng-select>
                            </div>

                            <div *ngIf="groupingType==='month' && compareData" class="col-12">
                                <label class="label">Month</label>
                                <ng-select [items]="compareMonths1" bindValue="month" bindLabel="desc"
                                    [(ngModel)]="compareMonthSel1" (change)="compareDate1Change()">
                                </ng-select>
                            </div>
                            <div *ngIf="groupingType==='quarter' && compareData" class="col-12">
                                <label class="label">Quarter</label>
                                <ng-select [(ngModel)]="compareQuarter1" (change)="compareDate1Change()">
                                    <ng-option *ngFor="let quarter of QuaterList" [value]="quarter.value">{{quarter.title}}</ng-option>
                                 </ng-select>
                            </div>
                        </div>
                        <br />
                        <div class="offset-lg-4 col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='day' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{dailyoerTextCompare1}}
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <span class="card-val">{{daily1Mt | number : '1.2-2'}} %</span>
                                            <br />
                                            <span class="text-muted mb-0 card-variance-budget">Budget:
                                            </span>
                                            <span class="card-variance-budget">{{daily1Budget | number :
                                                '1.2-2'}} %</span>
                                        </div>
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <div class="row">
                                                <div class="d-flex card-variance-container">
                                                    <span class="text-truncate card-variance">Var:
                                                    </span><span class="badge font-size-12 card-variance"
                                                        [ngClass]="daily1VarPer >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{daily1VarPer | number : '1.2-2'}} %
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="offset-lg-4 col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='day' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{dailyffbTextCompare1}}
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-7 col-md-6 col-sm-12 hidewebrecv">
                                            <div class="col-lg-12 col-md-12 col-sm-12">
                                                <h5>FFB Processed: {{daily1FfbPrcss | number : '1.2-2'}} mt</h5>
                                                <p class="text-muted text-truncate mb-0">FFB Received: {{daily1FfbRecv | number
                                                    : '1.2-2'}} mt</p>
                                            </div>
                                        </div>
                                        <div class="col-lg-7 col-md-6 col-sm-12 hiderecv">
                                            <div class="col-lg-12 col-md-12 col-sm-12">
                                                <h5>FFB Processed: {{daily1FfbPrcss | number : '1.2-2'}} mt</h5>
                                            </div>
                                            <div class="col-lg-12 col-md-12 col-sm-12">
                                                <p class="text-muted text-truncate mb-0">FFB Received: </p>
                                                    <p class="text-muted text-truncate mb-0">{{daily1FfbRecv | number
                                                        : '1.2-2'}} mt</p>
                                            </div>
                                        </div>
                                        <div class="col-lg-5 col-md-6 col-sm-12 variance-container">
                                            <!-- <div class="row">
                                                <div class="d-flex">
                                                    <span class="text-truncate">Var: </span><span class="badge font-size-12"
                                                        [ngClass]="dailyFfbRecv >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{dailyFfbRecv | number : '1.2-2'}} mt</span>
                                                </div>
                                            </div> -->
                                            <div class="row hiderecv">
                                                <div class="d-flex">
                                                    <span class="text-truncate col-sm-12 col-xs-12">FFB Balance: </span>
                                                </div>
                                                <div class="d-flex"><span class="badge font-size-12 col-sm-12 col-xs-12"
                                                        [ngClass]="daily1FfbBal >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{daily1FfbBal | number : '1.2-2'}} mt</span>
                                                </div>
                                            </div>
                                            <div class="row hidewebrecv">
                                                <div class="d-flex">
                                                    <span class="text-truncate">FFB Balance: </span><span class="badge font-size-12"
                                                        [ngClass]="daily1FfbBal >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{daily1FfbBal | number : '1.2-2'}} mt</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="offset-lg-4 col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='day' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{dailykerTextCompare1}}
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <span class="card-val">{{daily1KERMt | number : '1.2-2'}} %</span>
                                            <br />
                                            <span class="text-muted mb-0 card-variance-budget">Budget:
                                            </span>
                                            <span class="card-variance-budget">{{daily1KERBudget | number :
                                                '1.2-2'}} %</span>
                                        </div>
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <div class="row">
                                                <div class="d-flex card-variance-container">
                                                    <span class="text-truncate card-variance">Var:
                                                    </span><span class="badge font-size-12 card-variance"
                                                        [ngClass]="daily1KERVarMt >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{daily1KERVarMt | number : '1.2-2'}} %
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="offset-lg-4 col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='day' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{dailycpoTextCompare1}}
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-8 col-md-12 col-sm-12">
                                            <span class="card-val">CPO Production: {{daily1cpoProd | number : '1.2-2'}} mt</span>
                                            <br />
                                            <span class="text-muted mb-0 card-variance-budget">Balance:
                                            </span>
                                            <span class="card-variance-budget">{{daily1cpoBal | number :
                                                '1.2-2'}} mt</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="offset-lg-4 col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='day' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{dailypkTextCompare1}}
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-8 col-md-12 col-sm-12">
                                            <span class="card-val">PK Production: {{daily1PkProd | number : '1.2-2'}} mt</span>
                                            <br />
                                            <span class="text-muted mb-0 card-variance-budget">Balance:
                                            </span>
                                            <span class="card-variance-budget">{{daily1PkBal | number :
                                                '1.2-2'}} mt</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="offset-lg-4 col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='day' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                        class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{dailystTextCompare1}}
                                    </p>
                                        
                                        <div class="row table-responsive" *ngIf="!ismultipleou">
                                            <table id="basic-datatable"
                                            class="table table-bordered dt-responsive nowrap no-footer dtr-inline">
                                            <thead style="text-align:center">
                                                <tr>
                                                    <th>Tank</th>
                                                    <th>MT</th>
                                                    <th>FFA%</th>
                                                    <th>DOBI%</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr style="text-align:center">
                                                   <td style="text-align:center">
                                                    <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:center;text-align:center" *ngFor="let Stmill1 of St1MillList">
                                                        <h6>{{Stmill1.name}}</h6>
                                                    </div>
                                                   </td>
                                                   <td>
                                                    <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:right;text-align:right"*ngFor="let Stmill1 of St1MillList">
                                                        <h6>{{Stmill1.mt | number : '1.2-2'}}</h6>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:right;text-align:right"*ngFor="let Stmill1 of St1MillList">
                                                        <h6>{{Stmill1.ffa | number : '1.2-2'}}</h6>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12"style="display: flex;justify-content:right;text-align:right" *ngFor="let Stmill1 of St1MillList">
                                                        <h6> {{Stmill1.dobi | number : '1.2-2'}}</h6>
                                                    </div>
                                                </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                            
                                        </div>
                                        <div class="row"*ngIf="ismultipleou">
                                            <div class="card-padding-bottom col-lg-6 col-md-6 col-sm-12" *ngFor="let Stmill1 of St1MillList">
                                                <h5 class="text-muted text-truncate mb-0">{{Stmill1.name}}: {{Stmill1.mt | number : '1.2-2'}} mt</h5> 
                                            </div>
                                        </div>
                                </div>
                            </div>
                        </div>
                        <div class="offset-lg-4 col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='day' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                        class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{monthlydtTextCompare1}}
                                </p> 
                                <div class="row table-responsive"*ngIf="!ismultipleou">
                                    <table id="basic-datatable"
                                    class="table table-bordered dt-responsive nowrap no-footer dtr-inline">
                                    <thead style="text-align:center">
                                        <tr>
                                            <th>Tank</th>
                                            <th>MT</th>
                                            <th>FFA%</th>
                                            <th>DOBI%</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                           <td>
                                            <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:center;text-align:center" *ngFor="let Dtmill1 of Dt1MillList">
                                                <h6 style="display: flex;justify-content:center;text-align:center">{{Dtmill1.name}}</h6> 
                                            </div>
                                           </td>
                                           <td>
                                            <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12"style="display: flex;justify-content:right;text-align:right" *ngFor="let Dtmill1 of Dt1MillList">
                                                <h6 style="display: flex;justify-content:center;text-align:center">{{Dtmill1.mt | number : '1.2-2'}}</h6> 
                                            </div>
                                        </td>
                                        <td>
                                            <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12"style="display: flex;justify-content:right;text-align:right" *ngFor="let Dtmill1 of Dt1MillList">
                                                <h6 style="display: flex;justify-content:center;text-align:center">{{Dtmill1.ffa | number : '1.2-2'}}</h6> 
                                            </div>
                                        </td>
                                        <td >
                                            <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:right;text-align:right" *ngFor="let Dtmill1 of Dt1MillList">
                                                <h6 style="display: flex;justify-content:center;text-align:center">{{Dtmill1.dobi | number : '1.2-2'}}</h6> 
                                            </div>
                                        </td>
                                        </tr>
                                    </tbody>
                                  </table>
                                   
                                </div>
                                <div class="row"*ngIf="ismultipleou">
                                    <div class="card-padding-bottom col-lg-6 col-md-6 col-sm-12" *ngFor="let Dtmill1 of Dt1MillList">
                                        <h5 class="text-muted text-truncate mb-0">{{Dtmill1.name}}: {{Dtmill1.mt | number : '1.2-2'}} mt</h5> 
                                    </div>
                                </div>
                                        
                                </div>
                            </div>
                        </div>
                        <div class="offset-lg-4 col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='day' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{dailykernelTextCompare1}}
                                    </p>
                                    <div class="row">
                                        <div class="col-12" style="display: flex; justify-content:center;">
                                            <div>
                                                <h5 class="font-size-20">{{daily1kernalBunker | number : '1.2-2'}} mt</h5>
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                </div>
                            </div>
                        </div>
                        <div class="offset-lg-4 col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='month' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{monthlyoerTextCompare1}}
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <span class="card-val">{{monthly1Mt | number : '1.2-2'}} %</span>
                                            <br />
                                            <span class="text-muted mb-0 card-variance-budget">Budget:
                                            </span>
                                            <span class="card-variance-budget">{{monthly1Budget | number :
                                                '1.2-2'}} %</span>
                                        </div>
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <div class="row">
                                                <div class="d-flex card-variance-container">
                                                    <span class="text-truncate card-variance">Var:
                                                    </span><span class="badge font-size-12 card-variance"
                                                        [ngClass]="monthly1VarPer >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{monthly1VarPer | number : '1.2-2'}} %
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="offset-lg-4 col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='month' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{monthlykerTextCompare1}}
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <span class="card-val">{{monthly1KERMt | number : '1.2-2'}} %</span>
                                            <br />
                                            <span class="text-muted mb-0 card-variance-budget">Budget:
                                            </span>
                                            <span class="card-variance-budget">{{monthly1KERBudget | number :
                                                '1.2-2'}} %</span>
                                        </div>
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <div class="row">
                                                <div class="d-flex card-variance-container">
                                                    <span class="text-truncate card-variance">Var:
                                                    </span><span class="badge font-size-12 card-variance"
                                                        [ngClass]="monthly1KERVarMt >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{monthly1KERVarMt | number : '1.2-2'}} %
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="offset-lg-4 col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='month' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{monthlyffbTextCompare1}}
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-7 col-md-6 col-sm-12 hidewebrecv">
                                            <div class="col-lg-12 col-md-12 col-sm-12">
                                                <h5>FFB Processed: {{monthly1FfbPrcss | number : '1.2-2'}} mt</h5>
                                                <p class="text-muted text-truncate mb-0">FFB Received: {{monthly1FfbRecv | number
                                                    : '1.2-2'}} mt</p>
                                            </div>
                                        </div>
                                        <div class="col-lg-7 col-md-6 col-sm-12 hiderecv">
                                            <div class="col-lg-12 col-md-12 col-sm-12">
                                                <h5>FFB Processed: {{monthly1FfbPrcss | number : '1.2-2'}} mt</h5>
                                            </div>
                                            <div class="col-lg-12 col-md-12 col-sm-12">
                                                <p class="text-muted text-truncate mb-0">FFB Received: </p>
                                                    <p class="text-muted text-truncate mb-0">{{monthly1FfbRecv | number
                                                        : '1.2-2'}} mt</p>
                                            </div>
                                        </div>
                                        <div class="col-lg-5 col-md-6 col-sm-12 variance-container">
                                            <!-- <div class="row">
                                                <div class="d-flex">
                                                    <span class="text-truncate">Var: </span><span class="badge font-size-12"
                                                        [ngClass]="dailyFfbRecv >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{dailyFfbRecv | number : '1.2-2'}} mt</span>
                                                </div>
                                            </div> -->
                                            <div class="row hiderecv">
                                                <div class="d-flex">
                                                    <span class="text-truncate col-sm-12 col-xs-12">FFB Balance: </span>
                                                </div>
                                                <div class="d-flex"><span class="badge font-size-12 col-sm-12 col-xs-12"
                                                        [ngClass]="monthly1FfbBal >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{monthly1FfbBal | number : '1.2-2'}} mt</span>
                                                </div>
                                            </div>
                                            <div class="row hidewebrecv">
                                                <div class="d-flex">
                                                    <span class="text-truncate">FFB Balance: </span><span class="badge font-size-12"
                                                        [ngClass]="monthly1FfbBal >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{monthly1FfbBal | number : '1.2-2'}} mt</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>



                        <div class="offset-lg-4 col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='month' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{monthlycpoTextCompare1}}
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-8 col-md-12 col-sm-12">
                                            <span class="card-val">CPO Production: {{monthly1cpoProd | number : '1.2-2'}} mt</span>
                                            <br />
                                            <span class="text-muted mb-0 card-variance-budget">Balance:
                                            </span>
                                            <span class="card-variance-budget">{{monthly1cpoBal | number :
                                                '1.2-2'}} mt</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="offset-lg-4 col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='month' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{monthlypkTextCompare1}}
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-8 col-md-12 col-sm-12">
                                            <span class="card-val">PK Production: {{monthly1PkProd | number : '1.2-2'}} mt</span>
                                            <br />
                                            <span class="text-muted mb-0 card-variance-budget">Balance:
                                            </span>
                                            <span class="card-variance-budget">{{monthly1PkBal | number :
                                                '1.2-2'}} mt</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="offset-lg-4 col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='month' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                        class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{monthlystTextCompare1}}
                                </p>
                                <div class="row table-responsive" *ngIf="!ismultipleou">
                                    <table id="basic-datatable"
                                    class="table table-bordered dt-responsive nowrap no-footer dtr-inline">
                                    <thead style="text-align:center">
                                        <tr>
                                            <th>Tank</th>
                                            <th>MT</th>
                                            <th>FFA%</th>
                                            <th>DOBI%</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr style="text-align:center">
                                           <td style="text-align:center">
                                            <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:center;text-align:center" *ngFor="let Stmill1 of St1MillList">
                                                <h6>{{Stmill1.name}}</h6>
                                            </div>
                                           </td>
                                           <td>
                                            <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:right;text-align:right"*ngFor="let Stmill1 of St1MillList">
                                                <h6>{{Stmill1.mt | number : '1.2-2'}}</h6>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:right;text-align:right"*ngFor="let Stmill1 of St1MillList">
                                                <h6>{{Stmill1.ffa | number : '1.2-2'}}</h6>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12"style="display: flex;justify-content:right;text-align:right" *ngFor="let Stmill1 of St1MillList">
                                                <h6> {{Stmill1.dobi | number : '1.2-2'}}</h6>
                                            </div>
                                        </td>
                                        </tr>
                                    </tbody>
                                </table>
                                    
                                </div>
                                <div class="row"*ngIf="ismultipleou">
                                    <div class="card-padding-bottom col-lg-6 col-md-6 col-sm-12" *ngFor="let Stmill1 of St1MillList">
                                        <h5 class="text-muted text-truncate mb-0">{{Stmill1.name}}: {{Stmill1.mt | number : '1.2-2'}} mt</h5> 
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                        <div class="offset-lg-4 col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='month' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                        class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{monthlydtTextCompare1}}
                                </p>
                                <div class="row table-responsive"*ngIf="!ismultipleou">
                                    <table id="basic-datatable"
                                    class="table table-bordered dt-responsive nowrap no-footer dtr-inline">
                                    <thead style="text-align:center">
                                        <tr>
                                            <th>Tank</th>
                                            <th>MT</th>
                                            <th>FFA%</th>
                                            <th>DOBI%</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                           <td>
                                            <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:center;text-align:center" *ngFor="let Dtmill1 of Dt1MillList">
                                                <h6 style="display: flex;justify-content:center;text-align:center">{{Dtmill1.name}}</h6> 
                                            </div>
                                           </td>
                                           <td>
                                            <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12"style="display: flex;justify-content:right;text-align:right" *ngFor="let Dtmill1 of Dt1MillList">
                                                <h6 style="display: flex;justify-content:center;text-align:center">{{Dtmill1.mt | number : '1.2-2'}}</h6> 
                                            </div>
                                        </td>
                                        <td>
                                            <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12"style="display: flex;justify-content:right;text-align:right" *ngFor="let Dtmill1 of Dt1MillList">
                                                <h6 style="display: flex;justify-content:center;text-align:center">{{Dtmill1.ffa | number : '1.2-2'}}</h6> 
                                            </div>
                                        </td>
                                        <td >
                                            <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:right;text-align:right" *ngFor="let Dtmill1 of Dt1MillList">
                                                <h6 style="display: flex;justify-content:center;text-align:center">{{Dtmill1.dobi | number : '1.2-2'}}</h6> 
                                            </div>
                                        </td>
                                        </tr>
                                    </tbody>
                                  </table>
                                   
                                </div>
                                <div class="row"*ngIf="ismultipleou">
                                    <div class="card-padding-bottom col-lg-6 col-md-6 col-sm-12" *ngFor="let Dtmill1 of Dt1MillList">
                                        <h5 class="text-muted text-truncate mb-0">{{Dtmill1.name}}: {{Dtmill1.mt | number : '1.2-2'}} mt</h5> 
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                        <div class="offset-lg-4 col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='month' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{monthlykernelTextCompare1}}
                                    </p>
                                    <div class="row">
                                        <div class="col-12" style="display: flex; justify-content:center;">
                                            <div>
                                                <h5 class="font-size-20">{{monthly1kernalBunker | number : '1.2-2'}} mt</h5>
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                </div>
                            </div>
                        </div>
                        <div class="offset-lg-4 col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='year' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{yearlyoerTextCompare1}}
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <span class="card-val">{{yearly1Mt | number : '1.2-2'}} %</span>
                                            <br />
                                            <span class="text-muted mb-0 card-variance-budget">Budget:
                                            </span>
                                            <span class="card-variance-budget">{{yearly1Budget | number :
                                                '1.2-2'}} %</span>
                                        </div>
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <div class="row">
                                                <div class="d-flex card-variance-container">
                                                    <span class="text-truncate card-variance">Var:
                                                    </span><span class="badge font-size-12 card-variance"
                                                        [ngClass]="yearly1VarPer >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{yearly1VarPer | number : '1.2-2'}} %
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="offset-lg-4 col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType ==='range'|| groupingType ==='quarter' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{yearlyoerTextCompare1}}
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <span class="card-val">OER: {{yearly1Mt | number : '1.2-2'}} %</span>
                                            <br />
                                            <span class="text-muted mb-0 card-variance-budget">Budget:
                                            </span>
                                            <span class="card-variance-budget">{{yearly1Budget | number :
                                                '1.2-2'}} %</span>
                                        </div>
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <div class="row">
                                                <div class="d-flex card-variance-container">
                                                    <span class="text-truncate card-variance">Var:
                                                    </span><span class="badge font-size-12 card-variance"
                                                        [ngClass]="yearly1VarPer >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{yearly1VarPer | number : '1.2-2'}} %
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="offset-lg-4 col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType ==='range'|| groupingType ==='quarter' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{yearlykerTextCompare1}}
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <span class="card-val">KER: {{yearly1KERMt | number : '1.2-2'}} %</span>
                                            <br />
                                            <span class="text-muted mb-0 card-variance-budget">Budget:
                                            </span>
                                            <span class="card-variance-budget">{{yearly1KERBudget | number :
                                                '1.2-2'}} %</span>
                                        </div>
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <div class="row">
                                                <div class="d-flex card-variance-container">
                                                    <span class="text-truncate card-variance">Var:
                                                    </span><span class="badge font-size-12 card-variance"
                                                        [ngClass]="yearly1KERVarMt >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{yearly1KERVarMt | number : '1.2-2'}} %
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="offset-lg-4 col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='year' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{yearlykerTextCompare1}}
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <span class="card-val">{{yearly1KERMt | number : '1.2-2'}} %</span>
                                            <br />
                                            <span class="text-muted mb-0 card-variance-budget">Budget:
                                            </span>
                                            <span class="card-variance-budget">{{yearly1KERBudget | number :
                                                '1.2-2'}} %</span>
                                        </div>
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <div class="row">
                                                <div class="d-flex card-variance-container">
                                                    <span class="text-truncate card-variance">Var:
                                                    </span><span class="badge font-size-12 card-variance"
                                                        [ngClass]="yearly1KERVarMt >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{yearly1KERVarMt | number : '1.2-2'}} %
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="offset-lg-4 col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='year' || groupingType ==='range'|| groupingType ==='quarter' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{yearlyffbTextCompare1}}
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-7 col-md-6 col-sm-12 hidewebrecv">
                                            <div class="col-lg-12 col-md-12 col-sm-12">
                                                <h5>FFB Processed: {{yearly1FfbPrcss | number : '1.2-2'}} mt</h5>
                                                <p class="text-muted text-truncate mb-0">FFB Received: {{yearly1FfbRecv | number
                                                    : '1.2-2'}} mt</p>
                                            </div>
                                        </div>
                                        <div class="col-lg-7 col-md-6 col-sm-12 hiderecv">
                                            <div class="col-lg-12 col-md-12 col-sm-12">
                                                <h5>FFB Processed: {{yearly1FfbPrcss | number : '1.2-2'}} mt</h5>
                                            </div>
                                            <div class="col-lg-12 col-md-12 col-sm-12">
                                                <p class="text-muted text-truncate mb-0">FFB Received: </p>
                                                    <p class="text-muted text-truncate mb-0">{{yearly1FfbRecv | number
                                                        : '1.2-2'}} mt</p>
                                            </div>
                                        </div>
                                        <div class="col-lg-5 col-md-6 col-sm-12 variance-container">
                                            <!-- <div class="row">
                                                <div class="d-flex">
                                                    <span class="text-truncate">Var: </span><span class="badge font-size-12"
                                                        [ngClass]="dailyFfbRecv >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{dailyFfbRecv | number : '1.2-2'}} mt</span>
                                                </div>
                                            </div> -->
                                            <div class="row hiderecv">
                                                <div class="d-flex">
                                                    <span class="text-truncate col-sm-12 col-xs-12">FFB Balance: </span>
                                                </div>
                                                <div class="d-flex"><span class="badge font-size-12 col-sm-12 col-xs-12"
                                                        [ngClass]="yearly1FfbBal >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{yearly1FfbBal | number : '1.2-2'}} mt</span>
                                                </div>
                                            </div>
                                            <div class="row hidewebrecv">
                                                <div class="d-flex">
                                                    <span class="text-truncate">FFB Balance: </span><span class="badge font-size-12"
                                                        [ngClass]="yearly1FfbBal >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{yearly1FfbBal | number : '1.2-2'}} mt</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>



                        <div class="offset-lg-4 col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='year' || groupingType ==='range'|| groupingType ==='quarter' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{yearlycpoTextCompare1}}
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-8 col-md-12 col-sm-12">
                                            <span class="card-val">CPO Production: {{yearly1cpoProd | number : '1.2-2'}} mt</span>
                                            <br />
                                            <span class="text-muted mb-0 card-variance-budget">Balance:
                                            </span>
                                            <span class="card-variance-budget">{{yearly1cpoBal | number :
                                                '1.2-2'}} mt</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="offset-lg-4 col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='year' || groupingType ==='range'|| groupingType ==='quarter' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{yearlypkTextCompare1}}
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-8 col-md-12 col-sm-12">
                                            <span class="card-val">PK Production: {{yearly1PkProd | number : '1.2-2'}} mt</span>
                                            <br />
                                            <span class="text-muted mb-0 card-variance-budget">Balance:
                                            </span>
                                            <span class="card-variance-budget">{{yearly1PkBal | number :
                                                '1.2-2'}} mt</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="offset-lg-4 col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='year' || groupingType ==='range'|| groupingType ==='quarter' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                        class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{yearlystTextCompare1}}
                                </p>
                                <div class="row table-responsive" *ngIf="!ismultipleou">
                                    <table id="basic-datatable"
                                    class="table table-bordered dt-responsive nowrap no-footer dtr-inline">
                                    <thead style="text-align:center">
                                        <tr>
                                            <th>Tank</th>
                                            <th>MT</th>
                                            <th>FFA%</th>
                                            <th>DOBI%</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr style="text-align:center">
                                           <td style="text-align:center">
                                            <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:center;text-align:center" *ngFor="let Stmill1 of St1MillList">
                                                <h6>{{Stmill1.name}}</h6>
                                            </div>
                                           </td>
                                           <td>
                                            <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:right;text-align:right"*ngFor="let Stmill1 of St1MillList">
                                                <h6>{{Stmill1.mt | number : '1.2-2'}}</h6>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:right;text-align:right"*ngFor="let Stmill1 of St1MillList">
                                                <h6>{{Stmill1.ffa | number : '1.2-2'}}</h6>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12"style="display: flex;justify-content:right;text-align:right" *ngFor="let Stmill1 of St1MillList">
                                                <h6> {{Stmill1.dobi | number : '1.2-2'}}</h6>
                                            </div>
                                        </td>
                                        </tr>
                                    </tbody>
                                </table>
                                    
                                </div>
                                <div class="row"*ngIf="ismultipleou">
                                    <div class="card-padding-bottom col-lg-6 col-md-6 col-sm-12" *ngFor="let Stmill1 of St1MillList">
                                        <h5 class="text-muted text-truncate mb-0">{{Stmill1.name}}: {{Stmill1.mt | number : '1.2-2'}} mt</h5> 
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                        <div class="offset-lg-4 col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='year' || groupingType ==='range'|| groupingType ==='quarter' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                        class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{yearlydtTextCompare1}}
                                </p>
                                <div class="row table-responsive"*ngIf="!ismultipleou">
                                    <table id="basic-datatable"
                                    class="table table-bordered dt-responsive nowrap no-footer dtr-inline">
                                    <thead style="text-align:center">
                                        <tr>
                                            <th>Tank</th>
                                            <th>MT</th>
                                            <th>FFA%</th>
                                            <th>DOBI%</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                           <td>
                                            <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:center;text-align:center" *ngFor="let Dtmill1 of Dt1MillList">
                                                <h6 style="display: flex;justify-content:center;text-align:center">{{Dtmill1.name}}</h6> 
                                            </div>
                                           </td>
                                           <td>
                                            <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12"style="display: flex;justify-content:right;text-align:right" *ngFor="let Dtmill1 of Dt1MillList">
                                                <h6 style="display: flex;justify-content:center;text-align:center">{{Dtmill1.mt | number : '1.2-2'}}</h6> 
                                            </div>
                                        </td>
                                        <td>
                                            <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12"style="display: flex;justify-content:right;text-align:right" *ngFor="let Dtmill1 of Dt1MillList">
                                                <h6 style="display: flex;justify-content:center;text-align:center">{{Dtmill1.ffa | number : '1.2-2'}}</h6> 
                                            </div>
                                        </td>
                                        <td >
                                            <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:right;text-align:right" *ngFor="let Dtmill1 of Dt1MillList">
                                                <h6 style="display: flex;justify-content:center;text-align:center">{{Dtmill1.dobi | number : '1.2-2'}}</h6> 
                                            </div>
                                        </td>
                                        </tr>
                                    </tbody>
                                  </table>
                                   
                                </div>
                                <div class="row"*ngIf="ismultipleou">
                                    <div class="card-padding-bottom col-lg-6 col-md-6 col-sm-12" *ngFor="let Dtmill1 of Dt1MillList">
                                        <h5 class="text-muted text-truncate mb-0">{{Dtmill1.name}}: {{Dtmill1.mt | number : '1.2-2'}} mt</h5> 
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>

                        <div class="offset-lg-4 col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='year' || groupingType ==='range'|| groupingType ==='quarter' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{yearlykernelTextCompare1}}
                                    </p>
                                    <div class="row">
                                        <div class="col-12" style="display: flex; justify-content:center;">
                                            <div>
                                                <h5 class="font-size-20">{{yearly1kernalBunker | number : '1.2-2'}} mt</h5>
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                </div>
                            </div>
                        </div>
                        <div class="offset-lg-4 col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='monthly' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{monthlykernelTextCompare1}}
                                    </p>
                                    <div class="row">
                                        <div class="col-12" style="display: flex; justify-content:center;">
                                            <div>
                                                <h5 class="font-size-20">{{monthly1kernalBunker | number : '1.2-2'}} mt</h5>
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-6">

                        <div class="row col-lg-8 col-md-12 col-sm-12">
                            <div *ngIf="groupingType==='day' && compareData" class="col-12">
                                <label class="label">Date</label>
                                <input [(ngModel)]="compareDate2" (change)="compareDate2Change()" class="form-control"
                                    placeholder="dd/MM/yyyy" type="date">
                            </div>

                            <div *ngIf="(groupingType==='month' || groupingType==='year' || groupingType==='range'|| groupingType==='quarter') && compareData"
                                class="col-12">
                                <label class="label">Year</label>
                                <ng-select [items]="years" bindValue="year" [(ngModel)]="compareYearSel2"
                                    (ngModelChange)="selYearChangeCom(false)">
                                </ng-select>
                            </div>
                            <div *ngIf="groupingType==='quarter' && compareData" class="col-12">
                                <label class="label">Quarter</label>
                                <ng-select [(ngModel)]="compareQuarter2" (change)="compareDate2Change()">
                                    <ng-option *ngFor="let quarter of QuaterList" [value]="quarter.value">{{quarter.title}}</ng-option>
                                 </ng-select>
                            </div>
                            <div *ngIf="groupingType==='range' && compareData" class="col-12">
                                <label class="label">Month From (Year {{compareYearSel2}})</label>
                                <ng-select [items]="compareMonthsFrom2" bindValue="month" bindLabel="desc"
                                    [(ngModel)]="compareMonthFromSel2" (change)="selMonthFromCompareChange(false)">
                                </ng-select>
                            </div>

                            <div *ngIf="groupingType==='range' && compareData" class="col-12">
                                <label class="label">Month To (Year {{compareYearSel2}})</label>
                                <ng-select [items]="compareMonthsTo2" bindValue="month" bindLabel="desc"
                                    [(ngModel)]="compareMonthToSel2" (change)="compareDate2Change()">
                                </ng-select>
                            </div>

                            <div *ngIf="groupingType==='month' && compareData" class="col-12">
                                <label class="label">Month</label>
                                <ng-select [items]="compareMonths2" bindValue="month" bindLabel="desc"
                                    [(ngModel)]="compareMonthSel2" (change)="compareDate2Change()">
                                </ng-select>
                            </div>
                        </div>
                        <br />
                        <div class="col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='day' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{dailyoerTextCompare2}}
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <span class="card-val">{{daily2Mt | number : '1.2-2'}} %</span>
                                            <br />
                                            <span class="text-muted mb-0 card-variance-budget">Budget:
                                            </span>
                                            <span class="card-variance-budget">{{daily2Budget | number :
                                                '1.2-2'}} %</span>
                                        </div>
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <div class="row">
                                                <div class="d-flex card-variance-container">
                                                    <span class="text-muted card-variance">Var:
                                                    </span><span class="badge font-size-12 card-variance"
                                                        [ngClass]="daily2VarPer >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{daily2VarPer | number : '1.2-2'}} %
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='day' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{dailyffbTextCompare2}}
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-7 col-md-6 col-sm-12 hidewebrecv">
                                            <div class="col-lg-12 col-md-12 col-sm-12">
                                                <h5>FFB Processed: {{daily2FfbPrcss | number : '1.2-2'}} mt</h5>
                                                <p class="text-muted text-truncate mb-0">FFB Received: {{daily2FfbRecv | number
                                                    : '1.2-2'}} mt</p>
                                            </div>
                                        </div>
                                        <div class="col-lg-7 col-md-6 col-sm-12 hiderecv">
                                            <div class="col-lg-12 col-md-12 col-sm-12">
                                                <h5>FFB Processed: {{daily2FfbPrcss | number : '1.2-2'}} mt</h5>
                                            </div>
                                            <div class="col-lg-12 col-md-12 col-sm-12">
                                                <p class="text-muted text-truncate mb-0">FFB Received: </p>
                                                    <p class="text-muted text-truncate mb-0">{{daily2FfbRecv | number
                                                        : '1.2-2'}} mt</p>
                                            </div>
                                        </div>
                                        <div class="col-lg-5 col-md-6 col-sm-12 variance-container">
                                            <!-- <div class="row">
                                                <div class="d-flex">
                                                    <span class="text-truncate">Var: </span><span class="badge font-size-12"
                                                        [ngClass]="dailyFfbRecv >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{dailyFfbRecv | number : '1.2-2'}} mt</span>
                                                </div>
                                            </div> -->
                                            <div class="row hiderecv">
                                                <div class="d-flex">
                                                    <span class="text-truncate col-sm-12 col-xs-12">FFB Balance: </span>
                                                </div>
                                                <div class="d-flex"><span class="badge font-size-12 col-sm-12 col-xs-12"
                                                        [ngClass]="daily2FfbBal >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{daily2FfbBal | number : '1.2-2'}} mt</span>
                                                </div>
                                            </div>
                                            <div class="row hidewebrecv">
                                                <div class="d-flex">
                                                    <span class="text-truncate">FFB Balance: </span><span class="badge font-size-12"
                                                        [ngClass]="daily2FfbBal >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{daily2FfbBal | number : '1.2-2'}} mt</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='day' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{dailykerTextCompare2}}
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <span class="card-val">{{daily2KERMt | number : '1.2-2'}} %</span>
                                            <br />
                                            <span class="text-muted mb-0 card-variance-budget">Budget:
                                            </span>
                                            <span class="card-variance-budget">{{daily2KERBudget | number :
                                                '1.2-2'}} %</span>
                                        </div>
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <div class="row">
                                                <div class="d-flex card-variance-container">
                                                    <span class="text-truncate card-variance">Var:
                                                    </span><span class="badge font-size-12 card-variance"
                                                        [ngClass]="daily2KERVarMt >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{daily2KERVarMt | number : '1.2-2'}} %
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='day' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{dailycpoTextCompare2}}
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-8 col-md-12 col-sm-12">
                                            <span class="card-val">CPO Production: {{daily2cpoProd | number : '1.2-2'}} mt</span>
                                            <br />
                                            <span class="text-muted mb-0 card-variance-budget">Balance:
                                            </span>
                                            <span class="card-variance-budget">{{daily2cpoBal | number :
                                                '1.2-2'}} mt</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='day' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{dailypkTextCompare2}}
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-8 col-md-12 col-sm-12">
                                            <span class="card-val">PK Production: {{daily2PkProd | number : '1.2-2'}} mt</span>
                                            <br />
                                            <span class="text-muted mb-0 card-variance-budget">Balance:
                                            </span>
                                            <span class="card-variance-budget">{{daily2PkBal | number :
                                                '1.2-2'}} mt</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='day' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                        class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{monthlystTextCompare2}}
                                </p>
                                <div class="row table-responsive" *ngIf="!ismultipleou">
                                    <table id="basic-datatable"
                                    class="table table-bordered dt-responsive nowrap no-footer dtr-inline">
                                    <thead style="text-align:center">
                                        <tr>
                                            <th>Tank</th>
                                            <th>MT</th>
                                            <th>FFA%</th>
                                            <th>DOBI%</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr style="text-align:center">
                                           <td style="text-align:center">
                                            <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:center;text-align:center" *ngFor="let Stmill2 of St2MillList">
                                                <h6>{{Stmill2.name}}</h6>
                                            </div>
                                           </td>
                                           <td>
                                            <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:right;text-align:right"*ngFor="let Stmill2 of St2MillList">
                                                <h6>{{Stmill2.mt | number : '1.2-2'}}</h6>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:right;text-align:right"*ngFor="let Stmill2 of St2MillList">
                                                <h6>{{Stmill2.ffa | number : '1.2-2'}}</h6>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12"style="display: flex;justify-content:right;text-align:right" *ngFor="let Stmill2 of St2MillList">
                                                <h6> {{Stmill2.dobi | number : '1.2-2'}}</h6>
                                            </div>
                                        </td>
                                        </tr>
                                    </tbody>
                                </table>
                                    
                                </div>
                                <div class="row"*ngIf="ismultipleou">
                                    <div class="card-padding-bottom col-lg-6 col-md-6 col-sm-12" *ngFor="let Stmill2 of St2MillList">
                                        <h5 class="text-muted text-truncate mb-0">{{Stmill2.name}}: {{Stmill2.mt | number : '1.2-2'}} mt</h5> 
                                    </div>
                                </div>
                                        
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='day' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                        class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{monthlydtTextCompare2}}
                                </p>
                                <div class="row table-responsive"*ngIf="!ismultipleou">
                                    <table id="basic-datatable"
                                    class="table table-bordered dt-responsive nowrap no-footer dtr-inline">
                                    <thead style="text-align:center">
                                        <tr>
                                            <th>Tank</th>
                                            <th>MT</th>
                                            <th>FFA%</th>
                                            <th>DOBI%</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                           <td>
                                            <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:center;text-align:center" *ngFor="let Dtmill2 of Dt2MillList">
                                                <h6 style="display: flex;justify-content:center;text-align:center">{{Dtmill2.name}}</h6> 
                                            </div>
                                           </td>
                                           <td>
                                            <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12"style="display: flex;justify-content:right;text-align:right" *ngFor="let Dtmill2 of Dt2MillList">
                                                <h6 style="display: flex;justify-content:center;text-align:center">{{Dtmill2.mt | number : '1.2-2'}}</h6> 
                                            </div>
                                        </td>
                                        <td>
                                            <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12"style="display: flex;justify-content:right;text-align:right" *ngFor="let Dtmill2 of Dt2MillList">
                                                <h6 style="display: flex;justify-content:center;text-align:center">{{Dtmill2.ffa | number : '1.2-2'}}</h6> 
                                            </div>
                                        </td>
                                        <td >
                                            <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:right;text-align:right" *ngFor="let Dtmill2 of Dt2MillList">
                                                <h6 style="display: flex;justify-content:center;text-align:center">{{Dtmill2.dobi | number : '1.2-2'}}</h6> 
                                            </div>
                                        </td>
                                        </tr>
                                    </tbody>
                                  </table>
                                   
                                </div>
                                <div class="row"*ngIf="ismultipleou">
                                    <div class="card-padding-bottom col-lg-6 col-md-6 col-sm-12" *ngFor="let Dtmill2 of Dt2MillList">
                                        <h5 class="text-muted text-truncate mb-0">{{Dtmill2.name}}: {{Dtmill2.mt | number : '1.2-2'}} mt</h5> 
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='day' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{dailykernelTextCompare2}}
                                    </p>
                                    <div class="row">
                                        <div class="col-12" style="display: flex; justify-content:center;">
                                            <div>
                                                <h5 class="font-size-20">{{daily2kernalBunker | number : '1.2-2'}} mt</h5>
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='month' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{monthlyoerTextCompare2}}
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <span class="card-val">{{monthly2Mt | number : '1.2-2'}} %</span>
                                            <br />
                                            <span class="text-muted mb-0 card-variance-budget">Budget:
                                            </span>
                                            <span class="card-variance-budget">{{monthly2Budget | number :
                                                '1.2-2'}} %</span>
                                        </div>
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <div class="row">
                                                <div class="d-flex card-variance-container">
                                                    <span class="text-truncate card-variance">Var:
                                                    </span><span class="badge font-size-12 card-variance"
                                                        [ngClass]="monthly2VarPer >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{monthly2VarPer | number : '1.2-2'}} %
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='month' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{monthlykerTextCompare2}}
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <span class="card-val">{{monthly2KERMt | number : '1.2-2'}} %</span>
                                            <br />
                                            <span class="text-muted mb-0 card-variance-budget">Budget:
                                            </span>
                                            <span class="card-variance-budget">{{monthly2KERBudget | number :
                                                '1.2-2'}} %</span>
                                        </div>
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <div class="row">
                                                <div class="d-flex card-variance-container">
                                                    <span class="text-truncate card-variance">Var:
                                                    </span><span class="badge font-size-12 card-variance"
                                                        [ngClass]="monthly2KERVarMt >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{monthly2KERVarMt | number : '1.2-2'}} %
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='month' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{monthlyffbTextCompare2}}
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-7 col-md-6 col-sm-12 hidewebrecv">
                                            <div class="col-lg-12 col-md-12 col-sm-12">
                                                <h5>FFB Processed: {{monthly2FfbPrcss | number : '1.2-2'}} mt</h5>
                                                <p class="text-muted text-truncate mb-0">FFB Received: {{monthly2FfbRecv | number
                                                    : '1.2-2'}} mt</p>
                                            </div>
                                        </div>
                                        <div class="col-lg-7 col-md-6 col-sm-12 hiderecv">
                                            <div class="col-lg-12 col-md-12 col-sm-12">
                                                <h5>FFB Processed: {{monthly2FfbPrcss | number : '1.2-2'}} mt</h5>
                                            </div>
                                            <div class="col-lg-12 col-md-12 col-sm-12">
                                                <p class="text-muted text-truncate mb-0">FFB Received: </p>
                                                    <p class="text-muted text-truncate mb-0">{{monthly2FfbRecv | number
                                                        : '1.2-2'}} mt</p>
                                            </div>
                                        </div>
                                        <div class="col-lg-5 col-md-6 col-sm-12 variance-container">
                                            <!-- <div class="row">
                                                <div class="d-flex">
                                                    <span class="text-truncate">Var: </span><span class="badge font-size-12"
                                                        [ngClass]="dailyFfbRecv >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{dailyFfbRecv | number : '1.2-2'}} mt</span>
                                                </div>
                                            </div> -->
                                            <div class="row hiderecv">
                                                <div class="d-flex">
                                                    <span class="text-truncate col-sm-12 col-xs-12">FFB Balance: </span>
                                                </div>
                                                <div class="d-flex"><span class="badge font-size-12 col-sm-12 col-xs-12"
                                                        [ngClass]="monthly2FfbBal >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{monthly2FfbBal | number : '1.2-2'}} mt</span>
                                                </div>
                                            </div>
                                            <div class="row hidewebrecv">
                                                <div class="d-flex">
                                                    <span class="text-truncate">FFB Balance: </span><span class="badge font-size-12"
                                                        [ngClass]="monthly2FfbBal >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{monthly2FfbBal | number : '1.2-2'}} mt</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='month' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{monthlycpoTextCompare2}}
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-8 col-md-12 col-sm-12">
                                            <span class="card-val">CPO Production: {{monthly2cpoProd | number : '1.2-2'}} mt</span>
                                            <br />
                                            <span class="text-muted mb-0 card-variance-budget">Balance:
                                            </span>
                                            <span class="card-variance-budget">{{monthly2cpoBal | number :
                                                '1.2-2'}} mt</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='month' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{monthlypkTextCompare2}}
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-8 col-md-12 col-sm-12">
                                            <span class="card-val">PK Production: {{monthly2PkProd | number : '1.2-2'}} mt</span>
                                            <br />
                                            <span class="text-muted mb-0 card-variance-budget">Balance:
                                            </span>
                                            <span class="card-variance-budget">{{monthly2PkBal | number :
                                                '1.2-2'}} mt</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='month' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                        class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{monthlystTextCompare2}}
                                </p>
                                <div class="row table-responsive" *ngIf="!ismultipleou">
                                    <table id="basic-datatable"
                                    class="table table-bordered dt-responsive nowrap no-footer dtr-inline">
                                    <thead style="text-align:center">
                                        <tr>
                                            <th>Tank</th>
                                            <th>MT</th>
                                            <th>FFA%</th>
                                            <th>DOBI%</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr style="text-align:center">
                                           <td style="text-align:center">
                                            <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:center;text-align:center" *ngFor="let Stmill2 of St2MillList">
                                                <h6>{{Stmill2.name}}</h6>
                                            </div>
                                           </td>
                                           <td>
                                            <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:right;text-align:right"*ngFor="let Stmill2 of St2MillList">
                                                <h6>{{Stmill2.mt | number : '1.2-2'}}</h6>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:right;text-align:right"*ngFor="let Stmill2 of St2MillList">
                                                <h6>{{Stmill2.ffa | number : '1.2-2'}}</h6>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12"style="display: flex;justify-content:right;text-align:right" *ngFor="let Stmill2 of St2MillList">
                                                <h6> {{Stmill2.dobi | number : '1.2-2'}}</h6>
                                            </div>
                                        </td>
                                        </tr>
                                    </tbody>
                                </table>
                                    
                                </div>
                                <div class="row"*ngIf="ismultipleou">
                                    <div class="card-padding-bottom col-lg-6 col-md-6 col-sm-12" *ngFor="let Stmill2 of St2MillList">
                                        <h5 class="text-muted text-truncate mb-0">{{Stmill2.name}}: {{Stmill2.mt | number : '1.2-2'}} mt</h5> 
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='month' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                        class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{monthlydtTextCompare2}}
                                </p>
                                <div class="row table-responsive"*ngIf="!ismultipleou">
                                    <table id="basic-datatable"
                                    class="table table-bordered dt-responsive nowrap no-footer dtr-inline">
                                    <thead style="text-align:center">
                                        <tr>
                                            <th>Tank</th>
                                            <th>MT</th>
                                            <th>FFA%</th>
                                            <th>DOBI%</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                           <td>
                                            <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:center;text-align:center" *ngFor="let Dtmill2 of Dt2MillList">
                                                <h6 style="display: flex;justify-content:center;text-align:center">{{Dtmill2.name}}</h6> 
                                            </div>
                                           </td>
                                           <td>
                                            <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12"style="display: flex;justify-content:right;text-align:right" *ngFor="let Dtmill2 of Dt2MillList">
                                                <h6 style="display: flex;justify-content:center;text-align:center">{{Dtmill2.mt | number : '1.2-2'}}</h6> 
                                            </div>
                                        </td>
                                        <td>
                                            <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12"style="display: flex;justify-content:right;text-align:right" *ngFor="let Dtmill2 of Dt2MillList">
                                                <h6 style="display: flex;justify-content:center;text-align:center">{{Dtmill2.ffa | number : '1.2-2'}}</h6> 
                                            </div>
                                        </td>
                                        <td >
                                            <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:right;text-align:right" *ngFor="let Dtmill2 of Dt2MillList">
                                                <h6 style="display: flex;justify-content:center;text-align:center">{{Dtmill2.dobi | number : '1.2-2'}}</h6> 
                                            </div>
                                        </td>
                                        </tr>
                                    </tbody>
                                  </table>
                                   
                                </div>
                                <div class="row"*ngIf="ismultipleou">
                                    <div class="card-padding-bottom col-lg-6 col-md-6 col-sm-12" *ngFor="let Dtmill2 of Dt2MillList">
                                        <h5 class="text-muted text-truncate mb-0">{{Dtmill2.name}}: {{Dtmill2.mt | number : '1.2-2'}} mt</h5> 
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='month' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{monthlykernelTextCompare2}}
                                    </p>
                                    <div class="row">
                                        <div class="col-12" style="display: flex; justify-content:center;">
                                            <div>
                                                <h5 class="font-size-20">{{monthly2kernalBunker | number : '1.2-2'}} mt</h5>
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='year' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{yearlyoerTextCompare2}}
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <span class="card-val">{{yearly2Mt | number : '1.2-2'}} %</span>
                                            <br />
                                            <span class="text-muted mb-0 card-variance-budget">Budget:
                                            </span>
                                            <span class="card-variance-budget">{{yearly2Budget | number :
                                                '1.2-2'}} %</span>
                                        </div>
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <div class="row">
                                                <div class="d-flex card-variance-container">
                                                    <span class="text-truncate card-variance">Var:
                                                    </span><span class="badge font-size-12 card-variance"
                                                        [ngClass]="yearly2VarPer >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{yearly2VarPer | number : '1.2-2'}} %
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType ==='range'|| groupingType ==='quarter' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{yearlyoerTextCompare2}}
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <span class="card-val">OER: {{yearly2Mt | number : '1.2-2'}} %</span>
                                            <br />
                                            <span class="text-muted mb-0 card-variance-budget">Budget:
                                            </span>
                                            <span class="card-variance-budget">{{yearly2Budget | number :
                                                '1.2-2'}} %</span>
                                        </div>
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <div class="row">
                                                <div class="d-flex card-variance-container">
                                                    <span class="text-truncate card-variance">Var:
                                                    </span><span class="badge font-size-12 card-variance"
                                                        [ngClass]="yearly2VarPer >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{yearly2VarPer | number : '1.2-2'}} %
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='year' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{yearlykerTextCompare2}}
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <span class="card-val">{{yearly2KERMt | number : '1.2-2'}} %</span>
                                            <br />
                                            <span class="text-muted mb-0 card-variance-budget">Budget:
                                            </span>
                                            <span class="card-variance-budget">{{yearly2KERBudget | number :
                                                '1.2-2'}} %</span>
                                        </div>
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <div class="row">
                                                <div class="d-flex card-variance-container">
                                                    <span class="text-truncate card-variance">Var:
                                                    </span><span class="badge font-size-12 card-variance"
                                                        [ngClass]="yearly2KERVarMt >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{yearly2KERVarMt | number : '1.2-2'}} %
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType ==='range'|| groupingType ==='quarter' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{yearlykerTextCompare2}}
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <span class="card-val">KER: {{yearly2KERMt | number : '1.2-2'}} %</span>
                                            <br />
                                            <span class="text-muted mb-0 card-variance-budget">Budget:
                                            </span>
                                            <span class="card-variance-budget">{{yearly2KERBudget | number :
                                                '1.2-2'}} %</span>
                                        </div>
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <div class="row">
                                                <div class="d-flex card-variance-container">
                                                    <span class="text-truncate card-variance">Var:
                                                    </span><span class="badge font-size-12 card-variance"
                                                        [ngClass]="yearly2KERVarMt >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{yearly2KERVarMt | number : '1.2-2'}} %
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='year' || groupingType ==='range'|| groupingType ==='quarter' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{yearlyffbTextCompare2}}
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-7 col-md-6 col-sm-12 hidewebrecv">
                                            <div class="col-lg-12 col-md-12 col-sm-12">
                                                <h5>FFB Processed: {{yearly2FfbPrcss | number : '1.2-2'}} mt</h5>
                                                <p class="text-muted text-truncate mb-0">FFB Received: {{yearly2FfbRecv | number
                                                    : '1.2-2'}} mt</p>
                                            </div>
                                        </div>
                                        <div class="col-lg-7 col-md-6 col-sm-12 hiderecv">
                                            <div class="col-lg-12 col-md-12 col-sm-12">
                                                <h5>FFB Processed: {{yearly2FfbPrcss | number : '1.2-2'}} mt</h5>
                                            </div>
                                            <div class="col-lg-12 col-md-12 col-sm-12">
                                                <p class="text-muted text-truncate mb-0">FFB Received: </p>
                                                    <p class="text-muted text-truncate mb-0">{{yearly2FfbRecv | number
                                                        : '1.2-2'}} mt</p>
                                            </div>
                                        </div>
                                        <div class="col-lg-5 col-md-6 col-sm-12 variance-container">
                                            <!-- <div class="row">
                                                <div class="d-flex">
                                                    <span class="text-truncate">Var: </span><span class="badge font-size-12"
                                                        [ngClass]="dailyFfbRecv >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{dailyFfbRecv | number : '1.2-2'}} mt</span>
                                                </div>
                                            </div> -->
                                            <div class="row hiderecv">
                                                <div class="d-flex">
                                                    <span class="text-truncate col-sm-12 col-xs-12">FFB Balance: </span>
                                                </div>
                                                <div class="d-flex"><span class="badge font-size-12 col-sm-12 col-xs-12"
                                                        [ngClass]="yearly2FfbBal >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{yearly2FfbBal | number : '1.2-2'}} mt</span>
                                                </div>
                                            </div>
                                            <div class="row hidewebrecv">
                                                <div class="d-flex">
                                                    <span class="text-truncate">FFB Balance: </span><span class="badge font-size-12"
                                                        [ngClass]="yearly2FfbBal >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{yearly2FfbBal | number : '1.2-2'}} mt</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='year' || groupingType ==='range'|| groupingType ==='quarter' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{yearlycpoTextCompare2}}
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-8 col-md-12 col-sm-12">
                                            <span class="card-val">CPO Production: {{yearly2cpoProd | number : '1.2-2'}} mt</span>
                                            <br />
                                            <span class="text-muted mb-0 card-variance-budget">Balance:
                                            </span>
                                            <span class="card-variance-budget">{{yearly2cpoBal | number :
                                                '1.2-2'}} mt</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='year' || groupingType ==='range'|| groupingType ==='quarter' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{yearlypkTextCompare2}}
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-8 col-md-12 col-sm-12">
                                            <span class="card-val">PK Production: {{yearly2PkProd | number : '1.2-2'}} mt</span>
                                            <br />
                                            <span class="text-muted mb-0 card-variance-budget">Balance:
                                            </span>
                                            <span class="card-variance-budget">{{yearly2PkBal | number :
                                                '1.2-2'}} mt</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='year' || groupingType ==='range'|| groupingType ==='quarter' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                        class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{yearlystTextCompare2}}
                                </p>
                                <div class="row table-responsive" *ngIf="!ismultipleou">
                                    <table id="basic-datatable"
                                    class="table table-bordered dt-responsive nowrap no-footer dtr-inline">
                                    <thead style="text-align:center">
                                        <tr>
                                            <th>Tank</th>
                                            <th>MT</th>
                                            <th>FFA%</th>
                                            <th>DOBI%</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr style="text-align:center">
                                           <td style="text-align:center">
                                            <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:center;text-align:center" *ngFor="let Stmill2 of St2MillList">
                                                <h6>{{Stmill2.name}}</h6>
                                            </div>
                                           </td>
                                           <td>
                                            <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:right;text-align:right"*ngFor="let Stmill2 of St2MillList">
                                                <h6>{{Stmill2.mt | number : '1.2-2'}}</h6>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:right;text-align:right"*ngFor="let Stmill2 of St2MillList">
                                                <h6>{{Stmill2.ffa | number : '1.2-2'}}</h6>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12"style="display: flex;justify-content:right;text-align:right" *ngFor="let Stmill2 of St2MillList">
                                                <h6> {{Stmill2.dobi | number : '1.2-2'}}</h6>
                                            </div>
                                        </td>
                                        </tr>
                                    </tbody>
                                </table>
                                    
                                </div>
                                <div class="row"*ngIf="ismultipleou">
                                    <div class="card-padding-bottom col-lg-6 col-md-6 col-sm-12" *ngFor="let Stmill2 of St2MillList">
                                        <h5 class="text-muted text-truncate mb-0">{{Stmill2.name}}: {{Stmill2.mt | number : '1.2-2'}} mt</h5> 
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='year' || groupingType ==='range'|| groupingType ==='quarter' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                        class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{yearlydtTextCompare2}}
                                </p>
                                <div class="row table-responsive"*ngIf="!ismultipleou">
                                    <table id="basic-datatable"
                                    class="table table-bordered dt-responsive nowrap no-footer dtr-inline">
                                    <thead style="text-align:center">
                                        <tr>
                                            <th>Tank</th>
                                            <th>MT</th>
                                            <th>FFA%</th>
                                            <th>DOBI%</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                           <td>
                                            <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:center;text-align:center" *ngFor="let Dtmill2 of Dt2MillList">
                                                <h6 style="display: flex;justify-content:center;text-align:center">{{Dtmill2.name}}</h6> 
                                            </div>
                                           </td>
                                           <td>
                                            <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12"style="display: flex;justify-content:right;text-align:right" *ngFor="let Dtmill2 of Dt2MillList">
                                                <h6 style="display: flex;justify-content:center;text-align:center">{{Dtmill2.mt | number : '1.2-2'}}</h6> 
                                            </div>
                                        </td>
                                        <td>
                                            <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12"style="display: flex;justify-content:right;text-align:right" *ngFor="let Dtmill2 of Dt2MillList">
                                                <h6 style="display: flex;justify-content:center;text-align:center">{{Dtmill2.ffa | number : '1.2-2'}}</h6> 
                                            </div>
                                        </td>
                                        <td >
                                            <div class="card-padding-bottom col-lg-12 col-md-6 col-sm-12" style="display: flex;justify-content:right;text-align:right" *ngFor="let Dtmill2 of Dt2MillList">
                                                <h6 style="display: flex;justify-content:center;text-align:center">{{Dtmill2.dobi | number : '1.2-2'}}</h6> 
                                            </div>
                                        </td>
                                        </tr>
                                    </tbody>
                                  </table>
                                   
                                </div>
                                <div class="row"*ngIf="ismultipleou">
                                    <div class="card-padding-bottom col-lg-6 col-md-6 col-sm-12" *ngFor="let Dtmill2 of Dt2MillList">
                                        <h5 class="text-muted text-truncate mb-0">{{Dtmill2.name}}: {{Dtmill2.mt | number : '1.2-2'}} mt</h5> 
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType==='year' || groupingType ==='range'|| groupingType ==='quarter' && compareData">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{yearlykernelTextCompare2}}
                                    </p>
                                    <div class="row">
                                        <div class="col-12" style="display: flex; justify-content:center;">
                                            <div>
                                                <h5 class="font-size-20">{{yearly2kernalBunker | number : '1.2-2'}} mt</h5>
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                </div>
                            </div>
                        </div>


                        <!-- <div class="col-lg-8 col-md-12 col-sm-12">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 font-size-20"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <span class="card-val">{{yph2Mt | number : '1.2-2'}} mt/ha</span>
                                            <br />
                                            <span class="text-muted mb-0 card-variance-budget">Budget:
                                            </span>
                                            <span class="card-variance-budget">{{yph2Budget | number : '1.2-2'}}
                                                mt/ha</span>
                                        </div>
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <div class="row">
                                                <div class="d-flex card-variance-container">
                                                    <span class="text-truncate card-variance">Var: </span><span
                                                        class="badge font-size-12 card-variance"
                                                        [ngClass]="yph1VarPer >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{yph2VarPer | number : '1.2-2'}} %</span>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="d-flex card-variance-container">
                                                    <span class="text-truncate card-variance">Var:
                                                    </span><span class="badge font-size-12 card-variance"
                                                        [ngClass]="yph1VarMt >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{yph2VarMt | number : '1.2-2'}} mt/ha
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" type="ball-spin-clockwise" [fullScreen]="true">
    <p style="color: white"> Loading.. </p>
</ngx-spinner>